class General {

    constructor()
    {
        this.windowTopOffset;
        this.footerBottom;
        this.webshopTermekListTop;
        this.webshopkategTermekListTop;
        this.kcOriWidth;
        this.termekoldalCarouselItems;

        this.maxSefLista = 0;
        this.seflistablokkdivs = $(".seflistablokk .sef-item");

        this.canvasSwiper;




        this.init();
    }

    init() {

        if ($('.seflistablokk').length > 0) {
            setTimeout(() => {
                // this.maxHeighSeflista();
            }, 2000);
        }

        if (document.cookie.indexOf("eu-cookie-usage-accept") == -1) {
            setTimeout(() => {
                $('.pea_cook_wrapper').fadeIn(200);
                $('.pea_cook_wrapper .pea_cook_btn').on('click', (e) => {
                    e.preventDefault();
                    var egyev = new Date(new Date().getTime() + (3600 * 24 * 365 * 1000));
                    document.cookie = "eu-cookie-usage-accept=1; expires=" + egyev.toGMTString();

                    $('.pea_cook_wrapper').fadeOut(200);
                });

            }, 2000);
        }

        var diszt = $('html').data('disztributor');
        if (document.cookie.indexOf(diszt + "-gdpr-accepted") > -1) {
            var cookies = document.cookie.split(";");

            for (var i = 0; i < cookies.length; i++) {

                var cookie = cookies[i];
                var cdatas = cookie.split("=");
                var cname = cdatas[0].trim();
                var cvalue = +cdatas[1];

                if (cname.indexOf('-gdpr-accepted') > -1) {
                    if (cvalue == 1 || isNaN(cvalue)) {
                        cvalue = new Date(new Date().getTime() + (3600 * 24 * 365 * 1000)).getTime();
                    }
                    document.cookie = diszt + "-gdpr-accepted=" + cvalue + "; expires=Thu, 01 Jan 1970 00:00:00 GMT";
                    document.cookie = diszt + "-gdpr-accepted=" + cvalue + "; expires=" + new Date(cvalue).toGMTString();
                }
            }
        }


        // --------------------------------------- Post image/slider - height on mobile should be 2/3 of the window height ---------------------------------------

        if (window.innerWidth < 768) {
            $('.products-titleimage.valtozo').height($(window).height() * 0.66);
            $('.newsslider-2col').height($(window).height() * 0.66);
        }


        $('.language-switcher__trigger').on('click', (e) => {
            e.stopPropagation();
            $(e.currentTarget).toggleClass('opened');
            $('.language-switcher__list').toggleClass('language-switcher__list--open');
            if ($('.language-switcher__list').hasClass('language-switcher__list--open')) {
                $(".mobile-menu-kont").parent().stop().animate({ scrollTop: $('.mobile-menu-kont .toplevel:nth(4)').offset().top }, '150');
            }
        });
        $(window).on("click", () => {
            $('.language-switcher__list').removeClass('language-switcher__list--open');
        });


        if ($('.language-switcher.v2024').length > 0) {
            $('.language-switcher.v2024 .akt-orszag').on('click', (e) => {
                e.stopPropagation();
                e.preventDefault();
                $(e.currentTarget).toggleClass('opened');
                $('.language-switcher .orszag-list').toggleClass('d-none');
            });

            $(window).on('click', () => {
                $('.language-switcher .akt-orszag').removeClass('opened');
                $('.language-switcher .orszag-list').addClass('d-none');
            });
        }

        // --------------------------------------------------------- Mobile Menu Toggle ---------------------------------------------------------

        $('.mobile-nav-toggle').on("click", (e) => {

            if ($('.row.termekekmenu-kont .menupanel-left').length == 0) {
                $.get('/index.php/header/getmenu', (menuContent) => {
                    $('.row.termekekmenu-kont').html(menuContent);
                    this.menuTermekekContentEvents();
                    this.buildMobileMenuv2();
                    if ($('.row.termekekmenu-kont').hasClass('hide')) {
                        $('body').addClass('sticky-menu');
                    }
                    $(e.currentTarget).toggleClass('opened');
                    $('.navigation').toggleClass('open');
                });
            } else {
                $(e.currentTarget).toggleClass('opened');
                $('.navigation').toggleClass('open');
            }

        });

        // --------------------------------------------------------- Slider Setup ---------------------------------------------------

        $('.frontpage-slider').slick({
            infinite: true,
            speed: 800,
            slideToScroll: 1,
            slideToShow: 1,
            variableWidth: false,
            adaptiveHeight: true,
            fade: false,
            centerMode: false,
            autoplay: true,
            autoplaySpeed: 7000,
            arrows: true,
            prevArrow: '<span class="podor-arrow-left"></span>',
            nextArrow: '<span class="podor-arrow-right"></span>'
        });


        $('.singlepost-slider-gallery__slider').slick({
            arrows: true,
            infinite: true,
            centerMode: false,
            prevArrow: '<span class="black-table-left black-table-arrow"> <i class="fa fa-angle-left icon-white"></i> </span>',
            nextArrow: '<span class="black-table-right black-table-arrow"> <i class="fa fa-angle-right icon-white"></i> </span>',
            asNavFor: '.singlepost-slider-gallery__slider-thumbnails'
        });

        $('.singlepost-slider-gallery__slider-thumbnails').slick({
            //slideToShow: 6,
            slideToScroll: 1,
            centerMode: false,
            variableWidth: true,
            arrows: false,
            infinite: true,
            asNavFor: '.singlepost-slider-gallery__slider',
            focusOnSelect: true
        });

        $('.support-container').slick({
            slidesToShow: 5,
            slidesToScroll: 1,
            infinite: true,
            speed: 300,
            prevArrow: '<div class="suparrow owl-prev" style=""><i class="fa fa-angle-left icon-white"></i></div>',
            nextArrow: '<div class="suparrow owl-next" style=""><i class="fa fa-angle-right icon-white"></i></div>',
            responsive: [
                {
                    breakpoint: 980,
                    settings: {
                        slidesToShow: 4
                    }
                },
                {
                    breakpoint: 780,
                    settings: {
                        slidesToShow: 3
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 1
                    }
                }
            ]
        });

        $('#hir-slider').slick({
            slideToShow: 1,
            slideToScroll: 1,
            speed: 800,
            adaptiveHeight: true,
            variableWidth: true,
            dots: true,
            //autoplay: true,
            autoplaySpeed: 1500,
            prevArrow: '<a class="left carousel-control" href="#newsslider-2col" role="button" data-slide="prev"><span class="glyphicon glyphicon-chevron-left" aria-hidden="true"></span><span class="sr-only"></span></a>',
            nextArrow: '<a class="right carousel-control" href="#newsslider-2col" role="button" data-slide="next"><span class="glyphicon glyphicon-chevron-right" aria-hidden="true"></span><span class="sr-only"></span></a>',

        });

        $('#year-slider').slick({
            slideToShow: 1,
            slideToScroll: 1,
            speed: 800,
            //infinite: false,
            vertical: true,
            arrows: true,
            prevArrow: '<a class="up carousel-control" href="#year-slider" role="button" data-slide="prev"><span class="glyphicon glyphicon-chevron-up" aria-hidden="true"></span><span class="sr-only">Previous</span></a>',
            nextArrow: '<a class="down carousel-control" href="#year-slider" role="button" data-slide="next"><span class="glyphicon glyphicon-chevron-down" aria-hidden="true"></span><span class="sr-only">Next</span></a>'
        });



        $('.frontpage-slider-v2').slick({
            infinite: true,
            speed: 800,
            slideToScroll: 1,
            slideToShow: 1,
            variableWidth: false,
            adaptiveHeight: true,
            fade: false,
            centerMode: false,
            autoplay: true,
            autoplaySpeed: 5000,
            arrows: true,
            prevArrow: '<span class="podor-arrow-left"></span>',
            nextArrow: '<span class="podor-arrow-right"></span>'
        });


        // --------------------------------------------------------- Scroll to Top ---------------------------------------------------

        $('.scroll-top').on('click', () => {
            $("html, body").animate({ scrollTop: 0 }, "slow");
        });

        // --------------------------------------------------------- Scroll sticky ---------------------------------------------------

        if ($('.webshop-termek-list-kont').length > 0) {
            this.maxWKatch();
        }

        // --------------------------------------------------------- Mobil Dropdown ---------------------------------------------------

        $(' .navigation .navclose ').on('click', (e) => {
            $(e.currentTarget).closest('li').toggleClass('open');

            $('.termekkategoriak-mobile-submenu').toggleClass('open');


            if ($('.termekkategoriak-mobile-submenu').parents('li').hasClass('open')) {
                $('.termekkategoriak-mobile-submenu').removeClass('close');
            } else {
                $('.termekkategoriak-mobile-submenu').addClass('close');
            }
        });

        // --------------------------------------------------------- Productlist Carousel ---------------------------------------------------

        $('#productslider').slick({
            slideToShow: 1,
            slideToScroll: 1,
            variableWidth: false,
            prevArrow: '<span class="podor-arrow-left"></span>',
            nextArrow: '<span class="podor-arrow-right"></span>',
            responsive: [
                {
                    breakpoint: 800,
                    settings: {
                        arrows: false,
                    }
                }
            ]
        });

        // --------------------------------------------------------- Productlist Filters ---------------------------------------------------

        $('.flex-podor-productcategory-Products .biofilter-kont :checkbox').on('click', (e) => {

            if ($(e.currentTarget).parent().data('state') == 'off') {
                $(e.currentTarget).parent().data('state', 'on');
                $(e.currentTarget).parent().addClass('on');
            } else {
                $(e.currentTarget).parent().data('state', 'off');
                $(e.currentTarget).parent().removeClass('on');
            }

            // $('html, body').scrollTop($('.webshop-termek-list-kont').offset().top - 70);
            $("html, body").stop().animate({ scrollTop: $('.flex-podor-productcategory-Products .podor-productlist').offset().top - 40 }, '150');

            $('.flex-podor-productcategory-Products .product-not-bio').toggle();
        });


        // --------------------------------------------------------- Receptadatlap ---------------------------------------------------

        $('div.circleicon.print').on('click', () => {
            window.print();
        });

        /*
        $('#receptnyomtatasform').on('submit', (e) => {
            e.preventDefault();

            //var ujurl = window.location.href;
            var ujurl = window.location.href.replace('?rny', '');
            var printWindow = window.open(ujurl+'?print=1&hozzavalo_adag='+$('[name=hozzavalo_adag]').val()+'&hozzavalo_variant='+$('[name=hozzavalo_variant]').val(), '_blank');
            printWindow.print();
        });*/



        // --------------------------------------------------------- Isotope setup ---------------------------------------------------

        var pageUrl = window.location.href;
        if ($('.isotope-container').length > 0) {
            var $isotopeContainer = $('.isotope-container').isotope({ itemSelector: '.isotope-item' });
        } else if ($('.isotope-container-2').length > 0) {
            if ($("html").data('locale') == 'en_US') {
                var $isotopeContainer = $('.isotope-container-2').isotope({ itemSelector: '.isotope-item' });
            }
        }
        var filter = '';


        var beautyFilter = '.filter-beauty, .date';
        var healthFilter = '.filter-health, .date';
        var blackTableFilter = '.filter-podor-bt, .date';
        var chefFilter = '.filter-chefs, .date';
        var button;
        var monthClicked;

        if (pageUrl.indexOf('.filter-beauty') > -1) {
            button = $('a[data-filter=".filter-beauty"]');
            button.addClass('active');
            filter = beautyFilter;
        }
        if (pageUrl.indexOf('.filter-health') > -1) {
            button = $('a[data-filter=".filter-health"]');
            button.addClass('active');
            filter = healthFilter;
        }
        if (pageUrl.indexOf('.filter-podor-bt') > -1) {
            button = $('a[data-filter=".filter-podor-bt"]');
            button.addClass('active');
            filter = blackTableFilter;
        }
        if (pageUrl.indexOf('.filter-chefs') > -1) {
            button = $('a[data-filter=".filter-chefs"]');
            button.addClass('active');
            filter = chefFilter;
        }

        if (typeof $isotopeContainer != 'undefined') {
            $isotopeContainer.isotope({ filter: filter });

            var hash = window.location.hash;
            if (hash) {
                hash = hash.replace('#', '');
                if ($('body').hasClass('page-template-template-news')) {
                    var $filter = $('.isotope-filter a' + hash);
                    $filter.trigger("click");
                } else {
                    if (typeof $isotopeContainer != 'undefined') {
                        $isotopeContainer.isotope({ filter: hash });
                    }
                }
            }
        }

        $('.isotope-filter a').on('click', (e) => {
            if ($(e.currentTarget).hasClass('podor-bt') || $(e.currentTarget).hasClass('chefs')) {
            } else {
                e.preventDefault();

            }
            if ($(e.currentTarget).hasClass('active')) {
                filter = '*';
                $(e.currentTarget).removeClass('active');
            } else {
                $('.isotope-filter a.active').removeClass('active');
                filter = $(e.currentTarget).attr('data-filter');
                $(e.currentTarget).addClass('active');
            }
            if (filter) {
                filter += ', .date';
                $isotopeContainer.isotope({ filter: filter });
                $("html, body").stop().animate({ scrollTop: $('#magazin').offset().top - 300 }, '500');
            }

        });




        $('#news-datepicker .month input[type=radio]').on('click', (e) => {

            monthClicked = !monthClicked;

            $('#news-datepicker .month.active-filter').removeClass('inactive-filter');
            if (monthClicked) {

                var year = $('#news-datepicker .years input[type=radio]:checked').val(),
                    month = $(e.currentTarget).val(), baseFilter = ['.date'], yearFilter = '',
                    baseFilterStr = ''
                    ;

                if (typeof year == 'undefined') {
                    year = new Date().getFullYear();
                }

                yearFilter = 'yearmonth-' + year + month;
                baseFilter.push('.' + yearFilter);

                baseFilterStr = baseFilter.join(',').replace(/^, /, "").replace(/,$/, "");

                if (typeof $isotopeContainer == 'undefined') {
                    window.location.href = podorvilaga_url + '#' + baseFilterStr;

                } else {
                    $isotopeContainer.isotope({ filter: baseFilterStr });
                    $(e.currentTarget).parents('.month').removeClass('inactive-filter');
                }
            } else {
                $isotopeContainer.isotope({ filter: '' });
                $(e.currentTarget).parents('.month').addClass('inactive-filter');
            }
        });

        if (typeof $isotopeContainer != 'undefined') {
            $isotopeContainer.isotope('on', 'arrangeComplete', (filteredItems) => {
                this._wrapEveryThree();

                // var noItemsItem = $('.noitemsmessage-kont > div'),
                //     num = filteredItems.length;
                //
                // console.log(num)
                //
                // if (num > 1)
                // {
                //     $isotopeContainer.isotope( 'remove', $('.isotope-container .isotope-item.noitems') )
                // } else {
                //     if ($('.isotope-container .isotope-item.noitems').length == 0)
                //     {
                //         $isotopeContainer.isotope( 'prepended', noItemsItem )
                //     }
                // }
                // $isotopeContainer.isotope('reloadItems')
            });
        }



        // --------------------------------------------- News categories mobile behaviour ---------------------------------------------

        $(".news-categories__select-category").on('click', () => {
            $(".news-categories__category-list").toggleClass("news-categories__category-list--open");
            return false;
        });

        $(".news-categories__category-list a").on('click', (e) => {
            $(".news-categories__select-category li a").text($(e.currentTarget).text());
            $(".news-categories__category-list").removeClass("news-categories__category-list--open");
        });

        // ---------------------------------------------   MINŐSÉG TABS ----------------------------------------------

        $('.quality-text .tabs .toggle').on('click', (e) => {
            e.preventDefault();
            var $qualityTextContainer = $('.quality-text');

            var item = $(e.currentTarget).attr('data-toggle');
            if (item) {
                $('.quality-text .tabs .toggle.active').removeClass('active');
                $(e.currentTarget).addClass('active');
                $qualityTextContainer.find('.quality-text-item.show').removeClass('show').addClass('hide');
                $qualityTextContainer.find('.' + item).removeClass('hide').addClass('show');
            }
        });

        $('.quality-text .tabs-inner .toggle-inner').on('click', (e) => {
            e.preventDefault();
            var item = $(e.currentTarget).attr('data-toggle');
            if (item) {
                var $wrapper = $(e.currentTarget).parent().parent();
                $wrapper.find('.tabs-inner .toggle-inner.active').removeClass('active');
                $(e.currentTarget).addClass('active');
                $wrapper.find('.item-inner-content.show').removeClass('show').addClass('hide');
                $wrapper.find('.' + item).removeClass('hide').addClass('show');
            }
        });

        $('.btn.btn-recipe-search-categories').on('click', (e) => {
            e.preventDefault();
            $(e.currentTarget).toggleClass('active');
        });

        // ---------------------------------------------   KERESÉS ----------------------------------------------

        if ($('header.main-line .search-panel').length == 0) {

            $('.search').on("click", (e) => {
                e.preventDefault();
                $('.search-container').css('top', 'calc(' + $(window).scrollTop() + 'px)');
                $('.search-container').addClass('open');
            });

            $('.frontpage-navigation .navclose, .search-container .navclose').on("click", (e) => {
                e.preventDefault();
                $('.search-container').removeClass('open');
            });
        }

        // ---------------------------------------------   WEBSHOP BUTTON ----------------------------------------------
        /*
        var cartNum = $('.webshop-button .cart-num');
        var plus = $('.webshop-button .plus');
        var cart = $('.webshop-button .cart');
        var inShop = 0;
        $('.webshop-button').on("click", (e) => {
            e.preventDefault();
            inShop++;
            cartNum.html(inShop);
            plus.addClass('active');
            cart.addClass('active');
            setTimeout(() => {
                plus.removeClass('active');
            }, 1500);
            setTimeout(() => {
                cart.removeClass('active');
            }, 1000);

        });
    */
        // ---------------------------------------------   LOGIN HOVER ----------------------------------------------



        if (typeof shopKosarItems != 'undefined') {

            if ($("html").data('locale') == 'hu_HU' || $("html").data('locale') == 'de_DE') {
                $('#kosarlink1 .amount, #kosarlink2 .amount').each((index, element) => {
                    $(element).text(shopKosarItems);
                    if (+shopKosarItems > 9) {
                        $(element).addClass('wider');
                    }
                });
            } else {
                if (shopKosarItems > 0) {
                    $('#kosarlink1, #kosarlink2, #kosarlink3').attr('href', kosarShopURL);

                    // fejlécesek
                    //$('#kosarlink1 .amount, #kosarlink2 .amount').text(shopKosarItems);
                    $('#kosarlink1 .amount, #kosarlink2 .amount').each((index, element) => {
                        $(element).text(shopKosarItems);
                        if (+shopKosarItems > 9) {
                            $(element).addClass('wider');
                        }
                    });

                    // lábléc
                    $('#kosarlink3 .cart-num').text(shopKosarItems);
                }
            }


        }


        if (typeof shopLoginStatus != "undefined" && shopLoginStatus == true) {
            $('a.login')
                .addClass('logged-in')
                .attr('href', ($('.logout ul li:first a').attr('href')))
                .find('.t').text($('.logout ul li:first a').text());
            $('body').addClass('loggeduser');
        } else {
            $('body').removeClass('loggeduser');
        }

        $('a.login').removeClass('hide');


        $('.login.logged-in').on("hover", (e) => {
            $('.logout').addClass('open').removeClass('hide').show();
        }, () => { }
        );

        $('.logout').on("hover", () => { }, () => {
            $('.logout').removeClass('open').addClass('hide').hide();
        });

        // 2024

        if ($('header.top-line .top-right-items .userstatemenu:not(.mobile)').hasClass('logged-in')) {
            // Hover esemény a .userstatemenu elemre
            $('header.top-line .top-right-items .userstatemenu:not(.mobile)').hover(function () {
                // Megjeleníti a .submenu-t
                $('header.top-line .top-right-items .submenu').removeClass('d-none');
                $(this).addClass('opened');
            }, function () {
                // Nem történik semmi, mert a .submenu eltűnését a document mouseleave kezeli
            });

            // Mouseleave esemény a .userstatemenu és .submenu elemekre
            $(document).on('mouseleave', 'header.top-line .top-right-items .userstatemenu:not(.mobile), header.top-line .top-right-items .submenu', function (e) {
                if (!$(e.relatedTarget).closest('header.top-line .top-right-items .userstatemenu:not(.mobile), header.top-line .top-right-items .submenu').length) {
                    // Ha az egér elhagyja a .userstatemenu-t és a .submenu-t is, akkor elrejti a .submenu-t
                    $('header.top-line .top-right-items .submenu').addClass('d-none');
                    $('header.top-line .top-right-items .userstatemenu:not(.mobile)').removeClass('opened');
                }
            });

            // Ha az egér a .submenu fölé megy, ne tűnjön el
            $('header.top-line .top-right-items .submenu').hover(function () {
                // Megjelenik és marad a .submenu
                $(this).removeClass('d-none');
                $('header.top-line .top-right-items .userstatemenu:not(.mobile)').addClass('opened');
            }, function () {
                // Nem történik semmi, mert a .submenu eltűnését a document mouseleave kezeli
            });
        }

        this.setMenuBodyClasses();



        // --------------------------------------------- MENU DROPDOWN ---------------------------------------------


        var $frontpageNavigation = $('.frontpage-navigation');
        var $frontpageNavigationItem = $('.frontpage-navigation > div > ul > li > a');
        var $frontpageNavigationItemChild = $('.frontpage-navigation > div > ul > li > ul > li > a');
        var $headerNavigationItemChild = $('.header .navigation > ul > li > ul > li > a');


        $frontpageNavigationItem.on("hover", (e) => {
            if (this.isMobile())
                return;

            var $this = $(e.currentTarget);

            $('.frontpage-navigation > div > ul > li').height('');
            $('.frontpage-navigation > div > ul > li.open').removeClass('open');
            $this.siblings('.details').removeClass('hide');

            $this.closest('li')
                .addClass('open')
                .find('ul ul').hide();
        });


        $('.frontpage-navigation > div > ul > li > ul > li').on("hover", (e) => {
            if (this.isMobile())
                return;

            var $menu = $(e.currentTarget).closest('ul');
            $menu.siblings('.bg').addClass('show');
        }, () => {
            if (this.isMobile())
                return;

            var $menu = $(e.currentTarget).closest('ul');
            $menu.siblings('.bg').removeClass('show');
        });

        $frontpageNavigationItemChild.on("hover", (e) => {
            if (this.isMobile())
                return;

            $('.frontpage-navigation > div > ul > li > ul > li > ul').hide();
            $(e.currentTarget).closest('ul.level-2').siblings('.details').addClass('hide');
            var $ulToShow = $(e.currentTarget).closest('li').find('ul');
            if ($ulToShow) {
                var ulHeight = $ulToShow.outerHeight();
                if (ulHeight < 340) {
                    ulHeight = 340;
                }
                var $li = $ulToShow.closest('li.open');
                var liHeight = $li.outerHeight();

                $li.css({ 'height': ulHeight });
                $ulToShow.show();
            }
        });


        $('.frontpage-navigation > div > ul > li > ul > li > ul > li').on("hover", (e) => {
            if (this.isMobile())
                return;

            $('.termekmenu-sublevels').hide();
            $('.receptekmenu-sublevels').hide();
            var image = $(e.currentTarget).data('hoverimage');
            var $bgimage = $(e.currentTarget).closest('.level-1 > li').find('.bgimage');

            if (image.length > 0)
                $bgimage
                    .show()
                    .css({ 'background-image': 'url(' + image + ')' });
        }, (e) => {
            if (this.isMobile())
                return;

            var $bgimage = $(e.currentTarget).closest('.level-1 > li').find('.bgimage');
            $bgimage
                .hide()
                .css({ 'background-image': 'none' });
        });


        $('.frontpage-navigation > .container').on('mouseleave', (e) => {
            if (this.isMobile())
                return;

            $('.frontpage-navigation > div > ul > li.open').removeClass('open');
            $('.frontpage-navigation > div > ul > li').height('');
        });



        $('.frontpage-navigation > div > ul > li > .navclose').on("click", (e) => {
            $(e.currentTarget).closest('li').removeClass('open');
            $('.termekkategoriak-mobile-submenu').addClass('close');
        });



        // ==========================



        if ($('.limain-404-search form').length > 0) {
            $('.limain-404-search form').on('submit', (e) => {

                if ($(e.currentTarget).find('.search-input').val() == '') {
                    $(e.currentTarget).find('.search-input').addClass('errorborder');
                    setTimeout(() => { $('.limain-404-search form .search-input').removeClass('errorborder'); }, 3000);
                    return false;
                }

            });
        }

        this._initFancySelect();


        this._wrapEveryThree();

        if (navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1) {
            $('body').addClass('is_safari');
        }

        setTimeout(() => {
            this.phUpSlide();
        }, 1000);

        this.initEvents();


        if (typeof shopLoginStatus != "undefined" && shopLoginStatus == true) {
            if (shopLoginStatusLoc == false) {
                let menupontv2alap = $(".termekekmenu-kont .menupanel-right .subitem-body li a");
                let mobilemenualap = $(".header.v2 .mobile-menu-kont .sublevel.level-2 a");

                menupontv2alap.find('>span').removeClass('hide');
                menupontv2alap.find('>span').addClass('alapszazalek');
                menupontv2alap.find('>span .val').text(5);
                if (mobilemenualap.length > 0) {
                    mobilemenualap.find('>span').removeClass('hide');
                    mobilemenualap.find('>span').addClass('alapszazalek');
                    mobilemenualap.find('>span .val').text(5);
                }

                let menupontalap2024 = $("header.termekmenu-kont .desktop-menu .panels-kont .menupanel-right .subitem-body li a");
                let mobilemenualap2024 = $("header.termekmenu-kont .mobile-menu .panel.level-3 a");
                if (menupontalap2024.length > 0) {
                    menupontalap2024.find('>span').removeClass('hide');
                    menupontalap2024.find('>span').addClass('alapszazalek');
                    menupontalap2024.find('>span .val').text(5);
                }
                if (mobilemenualap2024.length > 0) {
                    mobilemenualap2024.find('>span').removeClass('hide');
                    mobilemenualap2024.find('>span').addClass('alapszazalek');
                    mobilemenualap2024.find('>span .val').text(5);
                }


            } else {
                if (typeof shopLoginStatusLocMarketingkedvezmenyAktiv != "undefined" && shopLoginStatusLocMarketingkedvezmenyMerteke != "") {
                    let menupontv2alap = $(".termekekmenu-kont .menupanel-right .subitem-body li a");
                    let mobilemenualap = $(".header.v2 .mobile-menu-kont .sublevel.level-2 a");

                    menupontv2alap.find('>span').removeClass('hide');
                    menupontv2alap.find('>span').addClass('alapszazalek');
                    menupontv2alap.find('>span .val').text(+shopLoginStatusLocMarketingkedvezmenyMerteke);
                    if (mobilemenualap.length > 0) {
                        mobilemenualap.find('>span').removeClass('hide');
                        mobilemenualap.find('>span').addClass('alapszazalek');
                        mobilemenualap.find('>span .val').text(+shopLoginStatusLocMarketingkedvezmenyMerteke);
                    }

                    let menupontalap2024 = $("header.termekmenu-kont .desktop-menu .panels-kont .menupanel-right .subitem-body li a");
                    let mobilemenualap2024 = $("header.termekmenu-kont .mobile-menu .panel.level-3 a");
                    if (menupontalap2024.length > 0) {
                        menupontalap2024.find('>span').removeClass('hide');
                        menupontalap2024.find('>span').addClass('alapszazalek');
                        menupontalap2024.find('>span .val').text(+shopLoginStatusLocMarketingkedvezmenyMerteke);
                    }
                    if (mobilemenualap2024.length > 0) {
                        mobilemenualap2024.find('>span').removeClass('hide');
                        mobilemenualap2024.find('>span').addClass('alapszazalek');
                        mobilemenualap2024.find('>span .val').text(+shopLoginStatusLocMarketingkedvezmenyMerteke);
                    }
                }
            }
        }

        if (typeof menukedvezmenydatab64 != 'undefined') {

            var menukedvData = JSON.parse(this.base64Decode(menukedvezmenydatab64));

            // menu v2024 mind kitöröljük
            var menupontvmobile2024 = $("header.termekmenu-kont .mobile-menu .panel a[id^='menu_termek_id_']");
            var menupontv2024 = $("header.termekmenu-kont .desktop-menu .subitem-body li a[id^='menu_termek_id_']");
            if (menupontv2024.length > 0) {
                menupontv2024.find('>span').addClass('hide');
                menupontv2024.find('>span').addClass('alapszazalek');
                menupontv2024.find('>span .val').text('');
                if (menupontvmobile2024.length > 0) {
                    menupontvmobile2024.find('>span').addClass('hide');
                    menupontvmobile2024.find('>span').addClass('alapszazalek');
                    menupontvmobile2024.find('>span .val').text('');
                }
            }

            $.each(menukedvData, function (aid, adata) {


                var menupont = $(".subitem-body li a#menu_termek_id_" + aid);
                if (menupont.length > 0) {
                    if (+adata.akcio_merteke > 0) {
                        menupont.find('>span').removeClass('hide alapszazalek');
                        menupont.find('>span .val').text(adata.akcio_merteke);
                    } else if (typeof adata.ceges_szazalek != "undefined") {
                        menupont.find('>span').removeClass('hide');
                        menupont.find('>span').addClass('alapszazalek');
                        menupont.find('>span .val').text(adata.ceges_szazalek);
                    } else if (typeof adata.prime_szazalek != "undefined") {
                        menupont.find('>span').removeClass('hide');
                        menupont.find('>span').addClass('alapszazalek');
                        menupont.find('>span .val').text(adata.prime_szazalek);
                    } else {
                        menupont.find('>span').addClass('hide');
                        menupont.find('>span').removeClass('alapszazalek');
                        menupont.find('>span .val').text('');
                    }
                }

                // menu v2
                var menupontv2 = $(".termekekmenu-kont .menupanel-right .subitem-body li a#menu_termek_id_" + aid);
                let mobilemenu = $(".header.v2 .mobile-menu-kont .sublevel.level-2 a#menu_termek_id_" + aid);

                if (menupontv2.length > 0) {
                    if (+adata.akcio_merteke > 0) {
                        menupontv2.find('>span').removeClass('hide alapszazalek');
                        menupontv2.find('>span .val').text(adata.akcio_merteke);
                        if (mobilemenu.length > 0) {
                            mobilemenu.find('>span').removeClass('hide alapszazalek');
                            mobilemenu.find('>span .val').text(adata.akcio_merteke);
                        }
                    } else if (typeof adata.ceges_szazalek != "undefined" && adata.ceges_szazalek > 0) {
                        menupontv2.find('>span').removeClass('hide');
                        menupontv2.find('>span').addClass('alapszazalek');
                        menupontv2.find('>span .val').text(adata.ceges_szazalek);
                        if (mobilemenu.length > 0) {
                            mobilemenu.find('>span').removeClass('hide');
                            mobilemenu.find('>span').addClass('alapszazalek');
                            mobilemenu.find('>span .val').text(adata.ceges_szazalek);
                        }
                    } else if (typeof adata.prime_szazalek != "undefined" && adata.prime_szazalek > 0) {
                        menupontv2.find('>span').removeClass('hide');
                        menupontv2.find('>span').addClass('alapszazalek');
                        menupontv2.find('>span .val').text(adata.prime_szazalek);
                        if (mobilemenu.length > 0) {
                            mobilemenu.find('>span').removeClass('hide');
                            mobilemenu.find('>span').addClass('alapszazalek');
                            mobilemenu.find('>span .val').text(adata.prime_szazalek);
                        }
                    } else {
                        menupontv2.find('>span').addClass('hide');
                        menupontv2.find('>span').addClass('alapszazalek');
                        menupontv2.find('>span .val').text('');
                        if (mobilemenu.length > 0) {
                            mobilemenu.find('>span').addClass('hide');
                            mobilemenu.find('>span').addClass('alapszazalek');
                            mobilemenu.find('>span .val').text('');
                        }
                    }
                }

                // menu v2024
                var menupontvmobile2024 = $("header.termekmenu-kont .mobile-menu .panel a[data-termek-id=" + aid + "]");
                var menupontv2024 = $("header.termekmenu-kont .desktop-menu .subitem-body li a#menu_termek_id_" + aid);
                if (menupontv2024.length > 0) {
                    menupontv2024.find('>span').addClass('hide');
                    menupontv2024.find('>span').addClass('alapszazalek');
                    menupontv2024.find('>span .val').text('');
                    if (menupontvmobile2024.length > 0) {
                        menupontvmobile2024.find('>span').addClass('hide');
                        menupontvmobile2024.find('>span').addClass('alapszazalek');
                        menupontvmobile2024.find('>span .val').text('');
                    }

                    if (+adata.akcio_merteke > 0) {
                        menupontv2024.find('>span').removeClass('hide alapszazalek');
                        menupontv2024.find('>span .val').text(adata.akcio_merteke);
                        if (menupontvmobile2024.length > 0) {
                            menupontvmobile2024.find('>span').removeClass('hide alapszazalek');
                            menupontvmobile2024.find('>span .val').text(adata.akcio_merteke);
                        }
                    } else if (typeof adata.ceges_szazalek != "undefined" && adata.ceges_szazalek > 0) {
                        menupontv2024.find('>span').removeClass('hide');
                        menupontv2024.find('>span').addClass('alapszazalek');
                        menupontv2024.find('>span .val').text(adata.ceges_szazalek);
                        if (menupontvmobile2024.length > 0) {
                            menupontvmobile2024.find('>span').removeClass('hide');
                            menupontvmobile2024.find('>span').addClass('alapszazalek');
                            menupontvmobile2024.find('>span .val').text(adata.ceges_szazalek);
                        }
                    } else if (typeof adata.prime_szazalek != "undefined" && adata.prime_szazalek > 0) {
                        menupontv2024.find('>span').removeClass('hide');
                        menupontv2024.find('>span').addClass('alapszazalek');
                        menupontv2024.find('>span .val').text(adata.prime_szazalek);
                        if (menupontvmobile2024.length > 0) {
                            menupontvmobile2024.find('>span').removeClass('hide');
                            menupontvmobile2024.find('>span').addClass('alapszazalek');
                            menupontvmobile2024.find('>span .val').text(adata.prime_szazalek);
                        }
                    }
                }

                // angebotemenu

                if ($('.subitem-panel-list-kont:not(.angebotemenu) li a').length > 0) {

                }

            });

        } else {
            if ($('.termekmenu-sublevels .level-3 a').length > 0) {
                $('.termekmenu-sublevels .level-3 a').each((i, el) => {

                    if ($(el).data("ardata") != '') {

                        try {

                            var akcio_merteke_value = +$(el).data('ardata-klub');

                            if (typeof shopLoginStatusFirm != "undefined" && shopLoginStatusFirm == true && shopLoginStatusLocCsok != true) {
                                akcio_merteke_value = +$(el).data('ardata-locon');
                            }

                            if (typeof shopLoginStatusLocCsok != "undefined" && shopLoginStatusLocCsok == true) {
                                akcio_merteke_value = +$(el).data('ardata-locon-ceges');
                            }

                            if (+akcio_merteke_value > 0) {
                                $(el).find('span .val').text(Math.round(akcio_merteke_value));
                            } else {
                                $(el).find('span').addClass('hide');
                            }

                            if (typeof shopLoginStatusFirm != "undefined" && shopLoginStatusFirm == true && shopLoginStatusLocCsok != true) {
                                //$(el).find('span').addClass('hide');
                            }

                        } catch (e) {

                        }
                    }

                });
            }

            if ($('.subitem-panel-list-kont:not(.angebotemenu) li a').length > 0) {
                $('.subitem-panel-list-kont:not(.angebotemenu) li a').each((i, el) => {

                    if ($(el).data("ardata") != '') {

                        try {

                            var akcio_merteke_value = +$(el).data('ardata-klub');

                            if (typeof shopLoginStatusFirm != "undefined" && shopLoginStatusFirm == true && shopLoginStatusLocCsok != true) {
                                akcio_merteke_value = +$(el).data('ardata-locon');
                            }

                            if (typeof shopLoginStatusLocCsok != "undefined" && shopLoginStatusLocCsok == true) {
                                akcio_merteke_value = +$(el).data('ardata-locon-ceges');
                            }

                            if (+akcio_merteke_value > 0) {
                                $(el).find('span .val').text(Math.round(akcio_merteke_value));
                            } else {
                                $(el).find('span').addClass('hide');
                            }

                            if (typeof shopLoginStatusFirm != "undefined" && shopLoginStatusFirm == true && shopLoginStatusLocCsok != true) {
                                //$(el).find('span').addClass('hide');
                            }


                        } catch (e) { }
                    }

                    if (typeof shopLoginStatusFirm != "undefined" && shopLoginStatusFirm == true && shopLoginStatusLocCsok != true) {
                        //$(el).find('span').addClass('hide');
                    }
                });
            }


        }

        // fuszervilágos video elindítása

        if ($('.cimlapi-ajanlo-2024.video-bg').length > 0) {


            const videoFuszervilagos = $('.cimlapi-ajanlo-2024.video-bg video')[0];
            const videoContainerFuszervilagos = $('.cimlapi-ajanlo-2024.video-bg')[0];

            const observerFuszervilagos = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        videoFuszervilagos.play();
                    } else {
                        // utolsó kockára áll be
                        videoFuszervilagos.pause();
                        if (+videoFuszervilagos.duration > 0) {
                            videoFuszervilagos.currentTime = +videoFuszervilagos.duration;
                        }
                    }
                });
            }, { threshold: 0.8 });

            observerFuszervilagos.observe(videoContainerFuszervilagos);
        }

        // slideshow videó elindítása ugyanez

        if ($('.frontpage-slider-v4-kont .frontpage-slider-v4 .slide-item.is-video').length > 0) {
            const videoSlideshow = $('.frontpage-slider-v4-kont .frontpage-slider-v4 .slide-item.is-video video')[0];
            const videoContainerSlideshow = $('.frontpage-slider-v4-kont .frontpage-slider-v4 .slide-item.is-video')[0];

            const observerSlideshow = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        videoSlideshow.play();
                    } else {
                        // utolsó kockára áll be
                        videoSlideshow.pause();
                        if (+videoSlideshow.duration > 0) {
                            videoSlideshow.currentTime = +videoSlideshow.duration;
                        }
                    }
                });
            }, { threshold: 0.9 });

            observerSlideshow.observe(videoContainerSlideshow);

            $('.frontpage-slider-v4-kont .frontpage-slider-v4 .slide-item.is-video').each((i, el) => {
                const video = $(el).find('video')[0];
                video.addEventListener('canplay', () => {
                    $(el).addClass('video-ready');
                });
            });


        }

        // termékadatlap 2024 carosel

        if ($('.termekadatlap-wrapper .image-filmstrip').length > 0) {
            if ($('.termekadatlap-wrapper .image-filmstrip .filmstrip-items .sitem').length > 1) {

                $('.termekadatlap-wrapper .image-filmstrip').removeClass('d-none');
                $('.termekadatlap-wrapper .image-canvas-arrows').removeClass('d-none');

                this.filterSlidesForMobile();

                let imageFilmstripSwiper = new Swiper('.termekadatlap-wrapper .image-filmstrip', {
                    spaceBetween: 10,
                    slidesPerView: 10,
                    loop: false,
                    direction: "vertical",
                    freeMode: true,
                    watchSlidesProgress: true,
                    centeredSlidesBounds: true,
                    breakpoints: {
                        991: {
                            grid: null
                        }
                    }
                });

                if ($('.termekadatlap-wrapper .image-filmstrip .filmstrip-items .sitem').length > 3) {
                    $('.termekadatlap-wrapper .image-filmstrip').addClass('thumb-2row');
                    if (this.isMobile()) {
                        imageFilmstripSwiper.params.grid = { rows: 2 };
                        imageFilmstripSwiper.update();
                    }
                }

                this.canvasSwiper = new Swiper('.termekadatlap-wrapper .image-canvas', {
                    slidesPerView: 1,
                    slidesPerGroup: 1,
                    spaceBetween: 0,

                    loop: true,

                    breakpoints: this.carouselBrakepoints,
                    navigation: {
                        nextEl: ".image-canvas-arrows .arrow-next",
                        prevEl: ".image-canvas-arrows .arrow-prev",
                    },

                    thumbs: {
                        swiper: imageFilmstripSwiper,
                    },

                    touchEventsTarget: 'container',

                    on: {
                        slideChange: function () {
                            if (this.slides[this.activeIndex].querySelector('video')) {
                                this.slides[this.activeIndex].querySelector('video').play();
                            }

                            if (this.slides[this.previousIndex].querySelector('video')) {
                                // megáll és az elejére ugrik
                                this.slides[this.previousIndex].querySelector('video').pause();
                                this.slides[this.previousIndex].querySelector('video').currentTime = 0;
                            }
                        }
                    }

                });
            }

        }


        // ajandekoldal buborékok animálása

        if ($('.ajandek-oldal-container .egyedi .bubbles').length > 0) {
            const bubblesContainer = $('.ajandek-oldal-container .egyedi .bubbles')[0];

            const thresholdValue = window.innerWidth < 991 ? 0.3 : 0.9;

            const observerSlideshow = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        // anim start
                        $('.ajandek-oldal-container .egyedi .bubbles .bubble').each((ind, bub) => {
                            setTimeout(() => { $(bub).addClass('animated'); }, ind * 150);
                        });
                    }
                });
            }, { threshold: thresholdValue });

            observerSlideshow.observe(bubblesContainer);
        }

        // receptoldal 2024
        // aktiv tab - ok extra elemei
        if ($('.receptekoldal2024 .main-tabs-kont .tablinks a.active').length > 0) {
            let extraSpans = $('<span></span><span></span>');
            extraSpans.appendTo('.receptekoldal2024 .main-tabs-kont .tablinks a.active');
        }


        if ($('.hirlevel-sargacsik-kont').length > 0)
        {
            $('.hirlevel-sargacsik-kont, .dropdown-arrow').on('click', (e) => {
                if (window.innerWidth <= 991 && e.target.tagName != 'A')
                {
                    e.preventDefault();
                    $('.sargacsik-container').addClass('opened');
                }
            });
        }

    }

    initEvents()
    {
        this._windowOnscrollEvent();

        if ($('.ujadatlap .adatlap-picture-kont.nagykepes').length > 0) {
            setTimeout(() => {
                $('.ujadatlap .adatlap-picture-kont.nagykepes').addClass('zoom-in');
                setTimeout(() => { $('.ujadatlap .adatlap-picture-kont.nagykepes').removeClass('zoom-in'); }, 2000);
            }, 1500);
        }

        $(window).on('resize', () => {

            this.setMenuBodyClasses();

            if ($('.seflistablokk').length > 0)
            {
                this.maxHeighSeflista();
            }

            if ($('.productcategory .productlist-category').length > 0)
            {
                //maxHeighKatelista();
            }

            if ($('.webshop-termek-list-kont').length > 0)
            {
                this.maxWKatch();
            }

            this.receptadatlapv2atrendezes();

            this.atmeretezesKezeles();

            this.ujadatlaptabsinit();

            this.filterSlidesForMobile();
            if (typeof this.canvasSwiper == 'object' && this.canvasSwiper != null)
            {
                this.canvasSwiper.update();
            }
        });


        this.newMenuInit();

        this.menuTermekekInit();

        MobileMenu2024.buildMobileMenuv2024();

        this.updateUjadatlapZoldplecsni();


        $('.clickable').each((ind, el) => {
            if ($(el).data('url') != "")
            {
                $(el).on("click", () => {
                    document.location.href = $(el).data('url');
                });
            }
        });

        if (typeof shopLoginStatus != "undefined")
        {

            if (shopLoginStatus == true)
            {
                $('.reglink-klub').addClass('hide');
            }

            if (
                $("html").data('locale') == 'de_DE'
                || $("html").data('locale') == 'en_US'
                || $("html").data('locale') == 'hu_HU'
                || $("html").data('locale') == 'sk_SK'
                || $("html").data('locale') == 'cs_CZ'
                || $("html").data('locale') == 'sl_SI'
                || $("html").data('locale') == 'en_AU'
                || $("html").data('locale') == 'fr_FR'
                )
            {
                if (typeof shopLoginStatusLoc != "undefined" && shopLoginStatusLoc == true)
                {
                    $('.reglink-locon:not(.nohide)').addClass('hide d-none');
                }
            }
        }

        if (window.innerWidth < 992) {
            this.receptadatlapv2atrendezes();
        }

        popupMessageSystem.init();
        popupPickupLista.init();
        popupSzettLista.init();



        if (!$("html").hasClass('ccm-edit-mode'))
        {
            if ($('.page-pure').length > 0)
            {
                $('.page-pure').find('.hide-pure').remove();
            } else {
                $('.ccm-page').find('.hide-none-pure').remove();
            }

            if (
                ($("html").data('locale') == 'de_DE' && $("html").data('page_id') == '210')
                || ($("html").data('locale') == 'hu_HU' && $("html").data('page_id') == '1')
                )
            {
                $('.elonyok-blokk-kontener .moveundertheslide').detach().insertAfter($('.home .frontpage-slider-v2.newmenu').next());
            } else if ($("html").data('locale') == 'en_US' && $("html").data('page_id') == '162') {
                $('.elonyok-blokk-kontener .moveundertheslide').detach().insertAfter($('.home .frontpage-slider-v2').next());

                // szépség oldal
            } else if ($("html").data('locale') == 'hu_HU' && $("html").data('page_id') == '4035') {
                $('.elonyok-blokk-kontener .moveundertheslide').detach().insertAfter($('.frontpage-slider-v2.newmenu').next());

                // szépség oldal - német
            } else if ($("html").data('locale') == 'de_DE' && $("html").data('page_id') == '4155') {
                $('.elonyok-blokk-kontener .moveundertheslide').detach().insertAfter($('.frontpage-slider-v2.newmenu').next());

                // szépség oldal - USA
            } else if ($("html").data('locale') == 'en_US' && $("html").data('page_id') == '4280') {
                $('.elonyok-blokk-kontener .moveundertheslide').detach().insertAfter($('.frontpage-slider-v2').next());

            } else {
                $('.hide-main').removeClass('hide-main');
            }
        }


        // receptoldalon vagyunk, nyomtatás
        if ($('.printpreview-window').length > 0)
        {
            $('.receptadatlap2 .receptsides .receptsides-right .ujhozzavalok').detach().appendTo($('.receptadatlap2 .receptsides .receptsides-left .print-hozzavalokkont'));
            $('.receptadatlap2 .receptsides .receptsides-left .print-hozzavalokkont').addClass('hozzavalo-side');
            $('.printpreview-window .ujhozzavalok .hozzavalok-box .settings-bar .person-counter input').attr('readonly', true);
        }

        if ($('[data-stack-replace-placeholder]').length > 0)
        {
            $('[data-stack-replace-placeholder]').each((i, st) => {
                var replace_id = $(st).data('stack-replace-placeholder');
                if (replace_id == 'pickup_elonyok' && typeof pickup_elonyok_html == 'string')
                {
                    var pickup_elonyok_html_decoded = base64Decode(pickup_elonyok_html);
                    $(pickup_elonyok_html_decoded).insertAfter($(st));
                    popupMessageSystem.initMessagehandlers();
                }
                if (replace_id == 'pickup_elonyok_v2' && typeof pickup_elonyok_v2_html == 'string')
                {
                    var pickup_elonyok_html_v2_decoded = base64Decode(pickup_elonyok_v2_html);
                    $(pickup_elonyok_html_v2_decoded).insertAfter($(st));
                    popupMessageSystem.initMessagehandlers();
                    if ($('.pickup_service_info_list_toggler').length > 0)
                    {
                        $('.pickup_service_info_list_toggler').on('click', (e) => {
                            e.preventDefault();
                            $('.pickup_service_info_list').toggleClass('hide');
                        });
                    }
                }

                if (replace_id == 'pickup_elonyok_v2024' && typeof pickup_elonyok_v2024_html == 'string')
                {
                    var pickup_elonyok_html_v2024_decoded = base64Decode(pickup_elonyok_v2024_html);
                    $(pickup_elonyok_html_v2024_decoded).insertAfter($(st));
                    popupMessageSystem.initMessagehandlers();
                    if ($('.pickup_service_info_list_toggler').length > 0)
                    {
                        $('.pickup_service_info_list_toggler').on('click', (e) => {
                            e.preventDefault();
                            $('.pickup_service_info_list').toggleClass('hide');
                        });
                    }
                }
            });
        }

        if ($('.header .navikont .lenyilo-reg-link').length > 0)
        {
            $('.header .navikont .lenyilo-reg-link a').on('click', (e) => {
                e.preventDefault();

                $(e.currentTarget).toggleClass('active');
                $('.header .lenyilo-reg-area').toggleClass('hide');
            });
        }


        if ($('.description-panel').length > 0)
        {
            if ((+$('.description-panel .full-text').height() + 26) < 125)
            {
                $('.description-panel .upclose').addClass('hide');
            }
        }



        this.multiPicsSelectorInit();

        var showReglinkDobozok = true;

        if (typeof shopLoginStatus != "undefined" && shopLoginStatus === true)
        {

            if ($('.header .navikont .lenyilo-reg-link').length > 0)
            {
                $('.header .navikont .lenyilo-reg-link:not(.nohide)').addClass('hide');
            }

            showReglinkDobozok = false;
        }

        if (!showReglinkDobozok)
        {
            $('.regisztracios-dobozok:not(.reg-v2)').addClass('hide r1');
            $('.regisztracios-dobozok.reg-v2 .dobozid-klubtag').addClass('hide r1');
        }

        if (typeof klubElonyokDobozElrejt != "undefined" && klubElonyokDobozElrejt === true)
        {
            $('.regisztracios-dobozok:not(.reg-v2)').addClass('hide r2');
            $('.regisztracios-dobozok.reg-v2 .dobozid-klubtag').addClass('hide r2');
        }

        $('.lenyilo-reg-area .regisztracios-dobozok').removeClass('hide');
        $('.kuponreglanding .regisztracios-dobozok').removeClass('hide');

        $('.lenyilo-reg-area .regisztracios-dobozok.reg-v2 .doboz-item:not(.only-menu)').remove();
        $('.flex-podor-frontpage .regisztracios-dobozok.reg-v2 .doboz-item.only-menu').remove();

        $('.lenyilo-reg-area .regisztracios-dobozok.reg-v3 .doboz-item-kont:not(.only-menu)').remove();
        $('.regisztracios-dobozok.reg-v3 .doboz-item-kont.only-menu').each((ind, dbo) => {
            if ($(dbo).parents('header').length == 0)
            {
                $(dbo).remove();
            }
        });


        // slide inicializálása
        let slideSpeedv4 = 5000;
        if ($('.ccm-page:not(.ccm-page-id-5479) .frontpage-slider-v4-kont').length > 0)
        {
            if ($('.frontpage-slider-v4-kont').data('slidespeed') != undefined)
            {
                slideSpeedv4 = +$('.frontpage-slider-v4-kont').data('slidespeed') * 1000;
            }
        }
        $('.ccm-page:not(.ccm-page-id-5479) .frontpage-slider-v4').slick({
            infinite: true,
            speed: 800,
            slideToScroll: 1,
            slideToShow: 1,
            variableWidth: false,
            adaptiveHeight: true,
            draggable: false,
            accessibility: true,
            swipe: false,
            fade: false,
            pauseOnHover: false,
            centerMode: false,
            autoplay: false,
            autoplaySpeed: slideSpeedv4,
            arrows: true,

            prevArrow: '<span class="podor-arrow-left"></span>',
            nextArrow: '<span class="podor-arrow-right"></span>'
        }).on('beforeChange', (event, slick, currentSlide, nextSlide) => {
            var currentSlideElement = $(slick.$slides.get(nextSlide));
            var video = currentSlideElement.find('video').get(0);
            if (video) {
                video.currentTime = 1;
            }

        }).on('afterChange', (event, slick, currentSlide) => {
            var currentSlideElement = $(slick.$slides.get(currentSlide));
            var video = currentSlideElement.find('video').get(0);
            if (video) {
                // video.currentTime = 0;
                video.play();
            }
        });

        $('.ccm-page:not(.ccm-page-id-5479) .frontpage-slider-v4').on('click', '.slick-slide', (e) => {
            var slideLink = $(e.currentTarget).find('a');
            if (slideLink.length > 0) {
                var slideLinkHref = slideLink.attr('href');
                document.location.href = slideLinkHref;
            }
        });

        $('.ccm-page-id-5479 .frontpage-slider-v4').slick({
            infinite: true,
            speed: 800,
            slideToScroll: 1,
            slideToShow: 1,
            variableWidth: false,
            adaptiveHeight: true,
            fade: false,
            pauseOnHover: false,
            centerMode: false,
            autoplay: true,
            autoplaySpeed: slideSpeedv4,
            arrows: true,
            dots: true,
            prevArrow: '<span class="podor-arrow-left"></span>',
            nextArrow: '<span class="podor-arrow-right"></span>'
        });

        // slick sider autoplay státusz kiírása
        console.log('slick autplay status:',$('.ccm-page:not(.ccm-page-id-5479) .frontpage-slider-v4').slick('slickGetOption', 'autoplay'));

        // videók letöltése, addig loader
        const videoSlides = $('.frontpage-slider-v4-kont .frontpage-slider-v4 .slide-item.is-video');
        let loadedVideos = 0;
        const totalVideos = videoSlides.length;

        // Ha nincs videó slide, azonnal elindítjuk az autoplayt
        if (totalVideos === 0) {
            // Autoplay elindítása
            $('.ccm-page:not(.ccm-page-id-5479) .frontpage-slider-v4').slick('slickSetOption', 'autoplay', true, false);
            $('.ccm-page:not(.ccm-page-id-5479) .frontpage-slider-v4').slick('slickPlay');
            console.log('slick autplay status:',$('.ccm-page:not(.ccm-page-id-5479) .frontpage-slider-v4').slick('slickGetOption', 'autoplay'));
        } else {
            // videók betöltésének figyelése
            videoSlides.each((i, el) => {
                const video = $(el).find('video')[0];

                video.addEventListener('canplay', () => {
                    $(el).addClass('video-ready');
                    loadedVideos++;

                    // Ha minden videó betöltődött, elindítjuk az autoplayt
                    if (loadedVideos === totalVideos) {
                        // Autoplay elindítása
                        $('.ccm-page:not(.ccm-page-id-5479) .frontpage-slider-v4').slick('slickSetOption', 'autoplay', true, false);
                        $('.ccm-page:not(.ccm-page-id-5479) .frontpage-slider-v4').slick('slickPlay');
                        console.log('slick autplay status:',$('.ccm-page:not(.ccm-page-id-5479) .frontpage-slider-v4').slick('slickGetOption', 'autoplay'));
                    }
                });

                // Ha a videó már betöltött (cached), akkor is számoljuk
                if (video.readyState >= 3) { // HAVE_FUTURE_DATA vagy HAVE_ENOUGH_DATA
                    $(el).addClass('video-ready');
                    loadedVideos++;

                    if (loadedVideos === totalVideos) {
                        // Autoplay elindítása
                        $('.ccm-page:not(.ccm-page-id-5479) .frontpage-slider-v4').slick('slickSetOption', 'autoplay', true, false);
                        $('.ccm-page:not(.ccm-page-id-5479) .frontpage-slider-v4').slick('slickPlay');
                        console.log('slick autplay status:',$('.ccm-page:not(.ccm-page-id-5479) .frontpage-slider-v4').slick('slickGetOption', 'autoplay'));
                    }
                }
            });
        }

        $('.ccm-notification-help-launcher').remove();

        if (shopLoginStatusLocKuponEnabled)
        {
            $('.kupnbanner-hosszu, .kupnbanner-negyzet').removeClass('hide');
        } else {
            $('.kupnbanner-hosszu, .kupnbanner-negyzet').remove();
        }

        if ($('[data-timeout-clear]').length > 0)
        {
            $('[data-timeout-clear]').each((i, el) => {
                var timeOutMs = +$(el).data('timeout-clear');

                if (timeOutMs > 0)
                {
                    setTimeout(() => { $(el).fadeOut(200); }, timeOutMs);
                }

            });
        }

        if ($('.main-content.ujadatlap .oldalcim').length > 0 || $('.termekadatlap-wrapper .right-panel .oldalcim').length > 0)
        {

            var fokateg = "" + $('.main-content.ujadatlap .oldalcim').data('fokategoria');
            var alkateg = "" + $('.main-content.ujadatlap .oldalcim').data('alkategoria');
            var tid = "" + $('.main-content.ujadatlap .oldalcim').data('id');

            if ($('.termekadatlap-wrapper .right-panel .oldalcim').length > 0)
            {
                fokateg = "" + $('.termekadatlap-wrapper .right-panel .oldalcim').data('fokategoria');
                alkateg = "" + $('.termekadatlap-wrapper .right-panel .oldalcim').data('alkategoria');
                tid = "" + $('.termekadatlap-wrapper .right-panel .oldalcim').data('id');
            }

            let basekategPanel = '.header.v2 .termekekmenu-kont .panels-kont .menupanel-left';
            let baseTermekpanel = '.header.v2 .termekekmenu-kont .panels-kont .menupanel-right .subitem-body';
            if (
                $('html').data('disztributor') == "hu"
                || $('html').data('disztributor') == "de"
                || $('html').data('disztributor') == "be"
                || $('html').data('disztributor') == "fr"
                || $('html').data('disztributor') == "au"
                || $('html').data('disztributor') == "us"
                || window.location.href.indexOf('design2024') != -1)
            {
                basekategPanel = 'header.termekmenu-kont .desktop-menu .panels-kont .menupanel-left';
                baseTermekpanel = 'header.termekmenu-kont .desktop-menu .panels-kont .menupanel-right .subitem-body';
            }

            $(basekategPanel + ' .items-kont a').removeClass('opened');

            $(basekategPanel + ' .items-kont a').each((ind, el) => {
                if (typeof $(el).data('real-kategoriak') != 'undefined')
                {
                    var menuKat = "" + $(el).data('real-kategoriak');

                    if (menuKat.indexOf('|') > -1)
                    {
                        var menukategs = menuKat.split('|');
                    } else {
                        var menukategs = [menuKat];
                    }

                    if (menukategs.indexOf(alkateg) > -1 || menukategs.indexOf(fokateg) > -1)
                    {
                        $(el).addClass('opened');
                        $(el).trigger('click');

                        if ($(baseTermekpanel + ' li a#menu_termek_id_' + tid).length > 0)
                        {
                            // $('.header.v2 .termekekmenu-kont .panels-kont .menupanel-right .subitem-body li a').removeClass('highlighted');
                            $(baseTermekpanel + ' li a#menu_termek_id_' + tid).addClass('highlighted');
                        }

                    } else {
                        var termek_nev = "" + $('.main-content.ujadatlap .oldalcim').text().trim();
                        $(baseTermekpanel + ' li a').each((ind, ael) => {
                            var aelnode = $(ael).clone();
                            $(aelnode).find('span').remove();
                            var nodename = $(aelnode).text().trim();
                            if (nodename == termek_nev)
                            {
                                $(ael).addClass('highlighted');
                            }
                            $(aelnode).remove();
                            nodename = null;
                        });
                    }



                }
            });
        }

        console.log('General.initEvents');
        this.email_signup_form_event_init();

        spicesMenu.init();
        termekAdatlapVideo.init();
        ujAdatlapUjarvalaszto.initHamarosanrendelheto();



        if ($('.row.termekekmenu-kont').length > 0)
        {
            this.buildMobileMenuv2();
        } else {
            this.buildMobileMenu();
        }


        this.atmeretezesKezeles();

        if ($('.frontpage-slider-v4-kont .left-side-kont .frontpage-slider-v4').length > 0)
        {
            var images = [];
            $('.frontpage-slider-v4-kont .left-side-kont .frontpage-slider-v4 .slide-item').each((i, sl) => {
                var pic_mobile = $(sl).data('pic_mobile');
                images[i] = new Image();
                images[i].src = $(sl).data('pic_mobile');
            });
        }

        if (window.location.href.indexOf('ujfelugro') != -1)
        {
            // $('.header.v2 .header-navigation-right-tools .tools .shop').on('click', (e) => {
            //     e.preventDefault();
            //     Kosar.showSidePanel();
            // })
        }

        Kosar.init();
        Kosar.loadBrowserSavedKosar();

        NewsletterPopup.init();
        InfluencerRegisztracio.init();


    }

    filterSlidesForMobile() {
        const isMobile = window.innerWidth < 980;
        const canvasSlides = document.querySelectorAll('.termekadatlap-wrapper .image-canvas .swiper-slide');

        canvasSlides.forEach(slide => {
            const hasVideo = slide.querySelector('video') !== null;
            if (hasVideo) {
                slide.style.display = isMobile ? 'none' : '';
            }
        });
    }


    setMenuBodyClasses()
    {
        if (this.isMobile())
        {
            $('body').addClass('sticked-menu');
        } else {

            if ($('.frontpage-slider-v4-kont').length > 0)
            {
                if ($(window).scrollTop() > $('.frontpage-slider-v4-kont').offset().top + ($('.frontpage-slider-v4-kont').height() ))
                {
                    $('body').addClass('sticked-menu');
                } else {
                    $('body').removeClass('sticked-menu');
                }
            }
        }
    }

    _wrapEveryThree()
    {
        if ($('.isotope-container .odd').length == 0)
        {
            var items = $('.isotope-container .isotope-item');
            var round = 0;
            for (var i = 0; i < items.length; i+=3)
            {
                var cls = ++round % 2 ? 'odd' : 'even';
                items.slice(i, i+3).wrapAll("<div class='"+cls+"'></div>");
            }
        }
    }

    _initFancySelect() {

        // if (typeof disableFancySelectIni != 'undefined') return true;

        $(".fancy-select-kont select").each((i, sel) => {
            $(sel).on('change', (e) => {

                let selText = "";

                let theValue = $(e.currentTarget).val();
                if (theValue == "")
                {
                    theValue = $(e.currentTarget).find('option[selected]').val();
                }

                if (theValue != "") {
                    selText = $(e.currentTarget).parent().find('option[value=' + theValue + ']').text();
                } else {
                    selText = $(e.currentTarget).parent().find('option:first').text();
                }

                if (selText == "" && $(e.currentTarget).parent().find('option:first').text() != "")
                {
                    selText = $(e.currentTarget).parent().find('option:first').text();
                }

                if ($(sel).data('pretext')) {

                    var prep_pretext = $(sel).data('pretext');
                    prep_pretext = prep_pretext.replace('ml', ' ml').replace('g', ' g');

                    selText = prep_pretext + selText;
                }

                if ($(sel).data('htmloptiontext'))
                {
                    selText = selText.replace(/^(.+) (.+)$/, "$1")+" <small>"+selText.replace(/^(.+) (.+)$/, "$2")+"</small>";
                }

                $(e.currentTarget).parents('.fancy-select-kont').find('.fancy-select-display .text').html(selText);
                $(e.currentTarget).parents('.fancy-select-kont').find('.fancy-select-display').toggleClass('first-selected', ($(e.currentTarget).prop('selectedIndex') == 0));
            });

            if ($(sel).parent().find('option[data-akcio_aktiv^="1 "]').length > 0) {
                var firstAkciosKisz = $(sel).parent().find('option[data-akcio_aktiv^="1 "]:first');
                $(sel).val(firstAkciosKisz.val());
            }

            if ($(sel).parent().hasClass('notriggerchange')) {
                let selText = "";
                if ($(sel).val() != "")
                {
                    selText = $(sel).parent().find('option[value=' + $(sel).val() + ']').html();
                } else {
                    selText = $(sel).parent().find('option:first').html();
                }
                if ($(sel).data('htmloptiontext'))
                {
                    selText = selText.replace(/^(.+) (.+)$/, "$1")+" <small>"+selText.replace(/^(.+) (.+)$/, "$2")+"</small>";
                }
                $(sel).parents('.fancy-select-kont').find('.fancy-select-display .text').html(selText);
            } else {
                $(sel).trigger('change');
            }

        });


        $(".fancy-select-kont-d2 select").each((i, sel) => {
            $(sel).on('change', (e) => {
                if ($(e.currentTarget).val() != "")
                {
                    var selText = $(e.currentTarget).parent().find('option[value=' + $(e.currentTarget).val() + ']').text();
                    $(e.currentTarget).parents('.fancy-select-kont-d2').find('.fancy-select-display .text').text(selText);
                }
            });

            if ($(sel).parent().hasClass('notriggerchange')) {
                if ($(e.currentTarget).val() != "")
                {
                    var selText = $(e.currentTarget).parent().find('option[value=' + $(e.currentTarget).val() + ']').text();
                    $(e.currentTarget).parents('.fancy-select-kont-d2').find('.fancy-select-display .text').text(selText);
                }
            } else {
                $(e.currentTarget).trigger('change');
            }
        });
    }

    _windowOnscrollEvent()
    {
        $(window).on('scroll', () => {
            this.setMenuBodyClasses();

            if ($('.footer-bottom').length > 0) {
                General.footerBottom = $('.footer-bottom').offset().top;

                General.windowTopOffset = $(window).scrollTop() + $(window).height();
                if(General.windowTopOffset >= General.footerBottom-10){
                    $('.scroll-top').css({
                        'position':'absolute',
                        'bottom':'auto',
                        'top': General.footerBottom-80
                    });
                } else {
                    let scrolBo = 20;

                    $('.scroll-top').css({
                        'position':'fixed',
                        'bottom': scrolBo+'px',
                        'top': 'auto'
                    });
                }
            }

            if ($('.webshop-termek-list-kont.v2').length > 0)
            {
                General.webshopTermekListTop = $('.webshop-termek-list-kont').offset().top;

                var topFix = 30;

                if ($('.biofilter-kont').length > 0)
                {
                    topFix = 53;
                }

                if ($('.webshop-termek-list-kont').hasClass('topleadhtml-view'))
                {
                    topFix = 10;
                }

                if ($(window).scrollTop() >= General.webshopTermekListTop - 10){

                    // $('.webshop-termek-list-kont.v2 .kategchooser-kont').css({
                    //     'position': 'fixed',
                    //     'top': topFix+'px',
                    //     // 'maxWidth': kcOriWidth > 0 ? kcOriWidth+'px' : 'auto',
                    //     'bottom': 'auto'
                    // }).addClass('fixed-floated');

                    // if ($('.biofilter-kont').length > 0)
                    // {
                    //     $('.biofilter-kont').addClass('fixed-topfloat');
                    //     $('.webshop-termek-list-kont .productlist-kont').css('marginTop', '124px');
                    // }


                    var termListBottom = ($('.webshop-termek-list-kont').offset().top + $('.webshop-termek-list-kont').height()) - $(window).scrollTop();

                    if (termListBottom < ($('.webshop-termek-list-kont.v2 .kategchooser-kont').height() + 70))
                    {
                        if ($('.webshop-termek-list-kont').hasClass('topleadhtml-view'))
                        {
                            // $('.webshop-termek-list-kont.v2 .kategchooser-kont').css({
                            //     'position': 'relative',
                            //     // 'top': 'auto',
                            //     'bottom': 'auto'
                            // }).removeClass('fixed-floated')

                        } else {

                            // $('.webshop-termek-list-kont.v2 .kategchooser-kont').css({
                            //     'position': 'relative',
                            //     'top': 'auto',
                            //     'bottom': 0
                            // }).removeClass('fixed-floated')
                        }

                        if ($('.biofilter-kont').length > 0)
                        {
                            $('.biofilter-kont').removeClass('fixed-topfloat');
                            $('.webshop-termek-list-kont .productlist-kont').css('marginTop', '0');
                        }

                    }

                } else {

                    if ($('.webshop-termek-list-kont').hasClass('topleadhtml-view'))
                    {

                        // $('.webshop-termek-list-kont.v2 .kategchooser-kont').css({
                        //   'position': 'relative',
                        //   'top': '-350px',
                        //   'maxWidth': 'auto',
                        //   'bottom': 'auto'
                        // }).removeClass('fixed-floated');
                    } else {

                        // $('.webshop-termek-list-kont.v2 .kategchooser-kont').css({
                        //   'position': 'relative',
                        //   // 'top': 'auto',
                        //   'maxWidth': 'auto',
                        //   'bottom': 'auto'
                        // }).removeClass('fixed-floated');

                    }


                    // if ($('.biofilter-kont').length > 0)
                    // {
                    //     $('.biofilter-kont').removeClass('fixed-topfloat');
                    //     $('.webshop-termek-list-kont .productlist-kont').css('marginTop', '0');
                    // }

                }
            }

            ///// v3-as új kategchooser
            if ($('.webshop-termek-list-kont.v3').length > 0)
            {
                General.webshopTermekListTop = $('.webshop-termek-list-kont').offset().top;

                var topFix = 30;

                if ($('.biofilter-kont').length > 0)
                {
                    topFix = 53;
                }

                if ($('.webshop-termek-list-kont').hasClass('topleadhtml-view'))
                {
                    topFix = 10;
                }

                if ($(window).scrollTop() >= General.webshopTermekListTop - 10){

                    // $('.webshop-termek-list-kont.v3 .kategchooser-kont').css({
                    //     'position': 'fixed',
                    //     'top': topFix+'px',
                    //     // 'maxWidth': kcOriWidth > 0 ? kcOriWidth+'px' : 'auto',
                    //     'bottom': 'auto'
                    // }).addClass('fixed-floated');

                    if ($('.biofilter-kont').length > 0)
                    {
                        $('.biofilter-kont').addClass('fixed-topfloat');
                        $('.webshop-termek-list-kont .productlist-kont').css('marginTop', '124px');
                    }


                    var termListBottom = ($('.webshop-termek-list-kont').offset().top + $('.webshop-termek-list-kont').height()) - $(window).scrollTop();

                    if (termListBottom < ($('.webshop-termek-list-kont.v3 .kategchooser-kont').height() + 70))
                    {
                        if ($('.webshop-termek-list-kont').hasClass('topleadhtml-view'))
                        {
                            // $('.webshop-termek-list-kont.v3 .kategchooser-kont').css({
                            //     'position': 'relative',
                            //     // 'top': 'auto',
                            //     'bottom': 'auto'
                            // }).removeClass('fixed-floated')

                        } else {

                            // $('.webshop-termek-list-kont.v3 .kategchooser-kont').css({
                            //     'position': 'relative',
                            //     'top': 'auto',
                            //     'bottom': 0
                            // }).removeClass('fixed-floated')
                        }

                        // if ($('.biofilter-kont').length > 0)
                        // {
                        //     $('.biofilter-kont').removeClass('fixed-topfloat');
                        //     $('.webshop-termek-list-kont .productlist-kont').css('marginTop', '0');
                        // }

                    }

                } else {

                    if ($('.webshop-termek-list-kont').hasClass('topleadhtml-view'))
                    {

                        // $('.webshop-termek-list-kont.v3 .kategchooser-kont').css({
                        //   'position': 'relative',
                        //   'top': '0',
                        //   'maxWidth': 'auto',
                        //   'bottom': 'auto'
                        // }).removeClass('fixed-floated');
                    } else {

                        // $('.webshop-termek-list-kont.v3 .kategchooser-kont').css({
                        //   'position': 'relative',
                        //   // 'top': 'auto',
                        //   'maxWidth': 'auto',
                        //   'bottom': 'auto'
                        // }).removeClass('fixed-floated');

                    }


                    // if ($('.biofilter-kont').length > 0)
                    // {
                    //     $('.biofilter-kont').removeClass('fixed-topfloat');
                    //     $('.webshop-termek-list-kont .productlist-kont').css('marginTop', '0');
                    // }

                }
            }

            if ($('.flex-podor-productcategory').length > 0 && $('.biofilter-kont').length > 0)
            {
                General.webshopkategTermekListTop = $('.flex-podor-productcategory').offset().top;

                var topFix = 0;

                if ($(window).scrollTop() >= General.webshopkategTermekListTop - 10)
                {

                    $('.biofilter-kont').addClass('fixed-topfloat');
                    $('.webshop-termek-list-kont .productlist-kont').css('marginTop', '124px');

                    var termkatListBottom = ($('.flex-podor-productcategory .productcategory').offset().top + $('.flex-podor-productcategory .productcategory').height()) - $(window).scrollTop();

                    if (termkatListBottom < ($('.biofilter-kont').height()))
                    {
                        $('.biofilter-kont').removeClass('fixed-topfloat');
                        $('.flex-podor-productcategory .productcategory').css('marginTop', '0');
                    }


                } else {
                    $('.biofilter-kont').removeClass('fixed-topfloat');
                    $('.webshop-termek-list-kont .productlist-kont').css('marginTop', '0');

                }
            }

            if ($('.webshop-termek-list-kont.static .filter-kont-row').length > 0)
            {
                General.webshopkategTermekListFilterTop = $('.webshop-termek-list-kont').offset().top;

                var topFix = 0;

                if ($(window).scrollTop() >= General.webshopkategTermekListFilterTop - 10)
                {

                    $('.filter-kont-row').addClass('fixed-topfloat');

                    var termkatListBottom = ($('.webshop-termek-list-kont').offset().top + $('.webshop-termek-list-kont').height()) - $(window).scrollTop();

                    if (termkatListBottom < ($('.filter-kont-row').height()))
                    {
                        $('.filter-kont-row').removeClass('fixed-topfloat');
                    }


                } else {
                    $('.filter-kont-row').removeClass('fixed-topfloat');

                }
            } else {

                if ($('.webshop-termek-list-kont.static .filter-kont').length > 0)
                {
                    General.webshopkategTermekListFilterTop = $('.webshop-termek-list-kont').offset().top;

                    var topFix = 0;

                    if ($(window).scrollTop() >= General.webshopkategTermekListFilterTop - 10)
                    {

                        $('.filter-kont').addClass('fixed-topfloat');

                        var termkatListBottom = ($('.webshop-termek-list-kont').offset().top + $('.webshop-termek-list-kont').height()) - $(window).scrollTop();

                        if (termkatListBottom < ($('.filter-kont').height()))
                        {
                            $('.filter-kont').removeClass('fixed-topfloat');
                        }


                    } else {
                        $('.filter-kont').removeClass('fixed-topfloat');

                    }
                }
            }

            if ($('.webshop-termek-list-kont.v3 #pagertrigger').length > 0)
            {
                var termekListTriggerTop = $('.webshop-termek-list-kont.v3 #pagertrigger').offset().top;

                var maxtop = 1160;

                if ($(window).scrollTop() >= (termekListTriggerTop - maxtop))
                {
                    if ($('.webshop-termek-list-kont:not(.static) .webshop-filter-result .podor-productlist .wait-datas').length == 0)
                    {

                        var nextpage = $('.webshop-termek-list-kont.v3 #pagertrigger').data('nextpage'),
                        kati = $('.webshop-termek-list-kont.v3 #pagertrigger').data('kati');

                        WebshopListaSzures.getPage(kati, nextpage, null, true);
                    }
                }
            }

            if ($('.spices-panel-kont').length > 0)
            {
                $('.spices-panel-kont').each((ind, el) => {
                    var spicePanel = $(el);

                    var panelTop = spicePanel.offset().top;

                    if (
                        checkVisible(spicePanel.find('.top-panel-kont'))
                        & $('.spices-menu-kont').data('quickjump') == 1
                    )
                    {
                        $('.spices-menu-kont').find('.menuitems a').removeClass('active');
                        $('.spices-menu-kont').find('.menuitems a').removeClass('active no-right-line');
                        var aktItem = $('.spices-menu-kont').find('.menuitems a[data-itemtarget='+spicePanel.attr('id')+']');
                        if (aktItem.length > 0)
                        {
                            $(aktItem).addClass('active');
                            $(aktItem).prev().addClass('no-right-line');
                        }
                    }


                    if (
                        $(window).scrollTop() > panelTop - (spicePanel.height() / 3)
                        && $(window).scrollTop() < panelTop + spicePanel.height()
                    )
                    {
                        spicePanel.find('.top-panel-kont').addClass('zoom-in');
                        setTimeout(() => { spicePanel.find('.top-panel-kont').removeClass('zoom-in'); }, 2000);
                    }
                });
            }

            if ($('.ujadatlap .adatlap-picture-kont.nagykepes').length > 0)
            {
                var adatlapNagykepPanel = $('.ujadatlap .adatlap-picture-kont.nagykepes');

                if (
                    $(window).scrollTop() == 0
                    || ($(window).scrollTop() > 100 && $(window).scrollTop() < 220)
                )
                {
                    if (!adatlapNagykepPanel.hasClass('zoom-in'))
                    {
                        adatlapNagykepPanel.addClass('zoom-in');
                        setTimeout(() => {
                            adatlapNagykepPanel.removeClass('zoom-in');
                        }, 2000);
                    }
                }

            }

        });
    }


    termekItemUpdateAr(el)
    {
        // if (disableFancySelectIni) return true;

        var selectorBase = $(el).parents('.selectors-cont'),
            db = selectorBase.find('select[name^="db_"]:first').val(),
            curr = selectorBase.data('aktcurrency'),
            dataStr = selectorBase.data('arak'),
            ardatas = JSON.parse(decodeURIComponent(dataStr));


        var kiszereles = selectorBase.find('select[name^="kiszereles_"]:first').val();
        var aktardata = ardatas[kiszereles];

        var clubkodos = false;

        if (typeof selectorBase.data('clubkodos') != 'undefined' && selectorBase.data('clubkodos') == 1)
        {
            clubkodos = true;
        }

        if (typeof aktardata != 'undefined' && aktardata != null)
        {

            //if (window.location.href.indexOf('navi4') != -1)
            {

                if (typeof aktardata.full_ar_data.ar_data.akcio_merteke != 'undefined')
                {
                    let akval = Math.round(aktardata.full_ar_data.ar_data.akcio_merteke);
                    akval = '-' + Math.abs(akval) + '%';
                    console.log(akval, "akval 1");
                    selectorBase.parents('.podor-product').find('.termeklogo-plecsni.akcio-aktiv span').text(akval);
                }

                if (aktardata.full_ar_data.ar_data.akcio_aktiv == 1 && aktardata.full_ar_data.ar_data.akcio_merteke > 0)
                {
                    selectorBase.parents('.podor-product').find('.klub-label.akcios').removeClass('hide');
                    selectorBase.parents('.podor-product').find('.klub-label:not(.akcios)').addClass('hide');
                    selectorBase.parents('.podor-product').find('.termeklogo-plecsni.akcio-aktiv').removeClass('hide');
                } else {
                    selectorBase.parents('.podor-product').find('.klub-label.akcios').addClass('hide');
                    selectorBase.parents('.podor-product').find('.klub-label:not(.akcios)').removeClass('hide');
                    selectorBase.parents('.podor-product').find('.termeklogo-plecsni.akcio-aktiv').addClass('hide');
                }
            }


            if (
                $("html").data('locale') == 'en_US'
                || $("html").data('locale') == 'en_UK'
                || $("html").data('locale') == 'en_AU'
                || $("html").data('locale') == 'fr_FR'
            )
            {
                var arakFormat = {
                    ar: curr + Kosar.number_format(aktardata.ar_szamol,2,".",","),
                    club_kodos_ar: curr + Kosar.number_format(aktardata.club_kodos_ar_szamol,2,".",","),
                    klubar: curr + Kosar.number_format(aktardata.klubar_szamol,2,".",","),
                    egysegar: curr + Kosar.number_format(aktardata.egysegar_value,2,".",","),
                    javasolt_ar: curr + Kosar.number_format(aktardata.full_ar_data.ar_data.price_javasolt_eladasi_ar,2,".",","),
                };

            } else if ($("html").data('locale') == 'hu_HU') {
                var arakFormat = {
                    ar: Kosar.number_format(aktardata.ar_szamol,0 ,"."," ") + ' ' + curr,
                    club_kodos_ar: Kosar.number_format(aktardata.club_kodos_ar_szamol,0 ,"."," ") + ' ' + curr,
                    klubar: Kosar.number_format(aktardata.klubar_szamol,0 ,"."," ") + ' ' + curr,
                    egysegar: Kosar.number_format(aktardata.egysegar_value,0 ,"."," ") + ' ' + curr,
                    javasolt_ar: Kosar.number_format(aktardata.full_ar_data.ar_data.price_javasolt_eladasi_ar,0,"."," ") + ' ' + curr,
                };

            } else {
                var arakFormat = {
                    ar: Kosar.number_format(aktardata.ar_szamol,2,",",".") + ' ' + curr,
                    club_kodos_ar: Kosar.number_format(aktardata.club_kodos_ar_szamol,2,",",".") + ' ' + curr,
                    klubar: Kosar.number_format(aktardata.klubar_szamol,2,",",".") + ' ' + curr,
                    egysegar: Kosar.number_format(aktardata.egysegar_value,2,",",".") + ' ' + curr,
                    javasolt_ar: Kosar.number_format(aktardata.full_ar_data.ar_data.price_javasolt_eladasi_ar,2,",",".") + ' ' + curr,
                };

            }

            selectorBase.parents('.podor-product').find('.prices-kont .price').text(arakFormat.ar);

            var klubarVal = 0, klubarvalSzamol = 0;
            if (clubkodos)
            {
                klubarVal = arakFormat.club_kodos_ar;
                klubarvalSzamol = aktardata.club_kodos_ar_szamol;
            } else {
                klubarVal = arakFormat.klubar;
                klubarvalSzamol = aktardata.klubar_szamol;
            }
            selectorBase.parents('.podor-product').find('.prices-kont .klub-price').text(klubarVal);


            if (shopLoginStatusLocCsok)
            {
                if ($("html").data('locale') == 'hu_HU')
                {
                    if ($("html").data('locale') == 'hu_HU') {

                        total = Math.round(aktardata.full_ar_data.ar_data.price_webshop_ar);
                        // klub_total = Math.round(aktardata.full_ar_data.ar_data.price_nagyker_ar);

                        value = Kosar.number_format(total,0,"."," ") + ' ' + curr;
                    } else if ($("html").data('locale') == 'de_DE') {

                        total = aktardata.full_ar_data.ar_data.price_webshop_ar;
                        // klub_total = Math.round(aktardata.full_ar_data.ar_data.price_nagyker_ar);

                        value = Kosar.number_format(total,2,",",".") + ' ' + curr;
                        // value_klub = Kosar.number_format(klub_total,0,"."," ") + ' ' + curr;

                        // selectorBase.parents('.podor-product').find('.prices-kont .klub-price').text(value_klub);
                    }
                }
                selectorBase.parents('.podor-product').find('.prices-kont .price').text(value);
            }

            if (klubarvalSzamol == 0)
            {
                selectorBase.addClass('hide');
                selectorBase.parents('.podor-product').find('.cartbutton-cont').addClass('hide');
                selectorBase.parents('.podor-product').find('.no-price').removeClass('hide');
                selectorBase.parents('.podor-product').find('.prices-kont').addClass('hide');
                selectorBase.parents('.podor-product').find('.select-button-kont').addClass('price-hide');
            }

            selectorBase.parents('.podor-product').find('.prices-kont .price-egysegar').text(aktardata.egysegar);

            if (selectorBase.parents('.podor-product').find('.prices-kont .javasolt-ar-line').length > 0)
            {
                if (aktardata.full_ar_data.ar_data.price_javasolt_eladasi_ar > 0)
                {
                    selectorBase.parents('.podor-product').find('.prices-kont .javasolt-ar-line').show();
                    selectorBase.parents('.podor-product').find('.prices-kont .javasolt-ar-line .javasolt-ar-text').text(arakFormat.javasolt_ar);
                } else {
                    selectorBase.parents('.podor-product').find('.prices-kont .javasolt-ar-line').hide();
                    selectorBase.parents('.podor-product').find('.prices-kont .javasolt-ar-line .javasolt-ar-text').text('');
                }
            }

            if (db > 0)
            {

                if ($("html").data('locale') == 'en_US' || $("html").data('locale') == 'en_UK' || $("html").data('locale') == 'en_AU')
                {
                    var total = Math.round((db * aktardata.ar_szamol)*1000)/1000;
                    if (clubkodos)
                    {
                        var klub_total = Math.round((db * aktardata.club_kodos_ar_szamol)*1000)/1000;
                    } else {
                        var klub_total = Math.round((db * aktardata.klubar_szamol)*1000)/1000;
                    }

                    var value = curr + Kosar.number_format(total,2,",",".");
                    var value_klub = curr + Kosar.number_format(klub_total,2,",",".");

                } else if ($("html").data('locale') == 'hu_HU') {
                    var total = Math.round(db * aktardata.ar_szamol);

                    if (clubkodos)
                    {
                        var klub_total = Math.round(db * aktardata.club_kodos_ar_szamol);
                    } else {
                        var klub_total = Math.round(db * aktardata.klubar_szamol);
                    }


                    var value = Kosar.number_format(total,0,"."," ") + ' ' + curr;
                    var value_klub = Kosar.number_format(klub_total,0,"."," ") + ' ' + curr;
                } else {
                    var total = Math.round((db * aktardata.ar_szamol)*1000)/1000;
                    if (clubkodos)
                    {
                        var klub_total = Math.round((db * aktardata.club_kodos_ar_szamol)*1000)/1000;
                    } else {
                        var klub_total = Math.round((db * aktardata.klubar_szamol)*1000)/1000;
                    }

                    var value = Kosar.number_format(total, 2,",",".") + ' ' + curr;
                    var value_klub = Kosar.number_format(klub_total,2,",",".") + ' ' + curr;
                }


                if (shopLoginStatusLocCsok)
                {
                    if ($("html").data('locale') == 'hu_HU')
                    {

                        total = Math.round(db * aktardata.full_ar_data.ar_data.price_webshop_ar);
                        klub_total = Math.round(db * aktardata.full_ar_data.ar_data.price_nagyker_brutto_ar);

                        value = Kosar.number_format(total,0,"."," ") + ' ' + curr;
                        value_klub = Kosar.number_format(klub_total,0,"."," ") + ' ' + curr;
                    }

                    if ($("html").data('locale') == 'de_DE')
                    {
                        total = db * aktardata.full_ar_data.ar_data.price_webshop_ar;
                        klub_total = db * aktardata.full_ar_data.ar_data.price_nagyker_brutto_ar;

                        value = Kosar.number_format(total,2,",",".") + ' ' + curr;
                        value_klub = Kosar.number_format(klub_total,2,",",".") + ' ' + curr;
                    }
                }

                selectorBase.parents('.podor-product').find('.prices-kont .price').text(value);
                selectorBase.parents('.podor-product').find('.prices-kont .klub-price').text(value_klub);
                selectorBase.parents('.podor-product').find('.prices-kont .price').data('akt_termek_ar', total);
                selectorBase.parents('.podor-product').find('.prices-kont .price').data('akt_termek_klub_ar', klub_total);
            }
        } else {
            selectorBase.addClass('hide');
            selectorBase.parents('.podor-product').find('.cartbutton-cont').addClass('hide');
            selectorBase.parents('.podor-product').find('.no-price').removeClass('hide');
            selectorBase.parents('.podor-product').find('.prices-kont').addClass('hide');
            selectorBase.parents('.podor-product').find('.select-button-kont').addClass('price-hide');

            // selectorBase.parents('.podor-product').find('.prices-kont .price').addClass('hide');
            // selectorBase.parents('.podor-product').find('.prices-kont .price-klub-kont').addClass('hide');

        }
    }

    termekItemAddKosar(el, mode, selectMode)
    {

        if (!selectMode)
        {
            var selectMode = 'multi';
        }

        if ($(el).attr('disabled'))
        {
            return false;
        }

        var datas = {};


        if (kozmetikaDesign)
        {
            datas["kozmetika"] = 1;
        }

        datas['termek_data'] = {
            'kep': $(el).parents('.podor-product').data('termek_kep_small'),
            'nev': $(el).parents('.podor-product').data('termek_nev')
        };

        var termek_id = $(el).parents('.podor-product').data('termek_id');

        if ($(el).data('pontbevaltas'))
        {
            datas['pontbevaltas'] = 1;
        }

        if (selectMode == 'single')
        {
            var maxNum = 0;
            var selectorBase = $(el).parents('.podor-product').find('.selectors-cont');

            datas['termek_id'] = $(el).parents('.podor-product').data('termek_id');

            datas['actcurrency'] = selectorBase.data('aktcurrency');

            datas['sessdata'] = typeof shopSessData == 'undefined' ? '' : shopSessData;

            // datas['debug'] = 1;

            var total = 0, klub_total = 0;

            selectorBase.find('select[name^=kiszereles_]').each((i, selo) => {
                if ($(selo).val() > 0)
                {
                    datas['type_'+(i+1)] = $(selo).attr('name').replace(/kiszereles_(.+)_db/, '$1');
                    datas['db_'+(i+1)] = $(selo).val();

                    var akt_termek_ar = $(selo).parents('.selectors-cont').find('.price-data-kont .price').data('akt_termek_ar');
                    var akt_termek_klub_ar = $(selo).parents('.selectors-cont').find('.price-data-kont .price').data('akt_termek_klub_ar');

                    total += +akt_termek_ar * $(selo).val();
                    klub_total += +akt_termek_klub_ar * $(selo).val();


                    maxNum += $(selo).val();
                }
            });

            datas['akt_termek_ar'] = total;
            datas['akt_termek_klub_ar'] = klub_total;

            db = maxNum;
        } else if (selectMode == 'szett') {
            datas['mode'] = 'szett';
            datas['szett_id'] = $(el).data('szett_id');
            datas['szett_csomag'] = $(el).data('szett_csomag');

            var itemBase = $(el).parents('.podor-product');
            if (itemBase.find('.darabszam-input input').length > 0)
            {
                datas['db_14'] = itemBase.find('.darabszam-input input').val();
            }

            var selectorBase = $(el).parents('.podor-product').find('.kezdoszett-items-list');

        } else {

            var ujlista = false;

            if ($(el).parents('.podor-product').find('.kiszereles-darabszam-select-kont .darabszam-input-kont .darabszam-input input').length > 0)
            {
                ujlista = true;
            }

            if (selectMode == 'ajandekutalvany')
            {
                ujlista = true;
                var selectorBase = $(el).parents('.podor-product').find('.utalvany-ertek-select-kont');
                datas['akt_termek_ar'] = selectorBase.parents('.podor-product').find('.utalvany-ertek-select-kont select').val();
                datas['mode'] = 'ajandekutalvany';

            } else {
                if (ujlista)
                {
                    var selectorBase = $(el).parents('.podor-product').find('.kiszereles-darabszam-select-kont'),
                        db = selectorBase.find('.darabszam-input input').val(),
                        kiszereles = selectorBase.find('.kiszerelesek-kont a.selected').data('kiszereles_type');
                } else {
                    var selectorBase = $(el).parents('.podor-product').find('.selectors-cont'),
                        db = selectorBase.find('select[name^="db_"]:first').val(),
                        kiszereles = selectorBase.find('select[name^="kiszereles_"]:first').val();
                }

                var curr = selectorBase.data('aktcurrency');

                datas['akt_termek_ar'] = selectorBase.parents('.podor-product').find('.prices-kont .price').data('akt_termek_ar');
                datas['akt_termek_klub_ar'] = selectorBase.parents('.podor-product').find('.prices-kont .price').data('akt_termek_klub_ar');
                datas['actcurrency'] = curr;

                datas['type_1'] = kiszereles;
                datas['db_1'] = db;
            }

            datas['termek_id'] = termek_id;
            datas['sessdata'] = typeof shopSessData == 'undefined' ? '' : shopSessData;
        }

        var validKiszereles = true;

        let kiszereles_obj = selectorBase.find('.kiszerelesek-kont a.selected');

        if ($(kiszereles_obj).data('kiszereles_nincs_ar_erdeklodjon') == 1)
        {
            return false;
        }

        var cart = $('.webshop-button-d2');
        var sidebarDisable = false;

        if (db > 0 || selectMode == 'ajandekutalvany' || selectMode == 'szett') {

            WebshopListaSzuresStatic.textFilterInputTermekadatlapCloseResults();



            var tItem = selectorBase.parents('.item');

            GTMDataPusher.listItemAddToCart(tItem, db);
            GtagDataPusher.listItemAddToCart(tItem, db);
            FBQDataPusher.listItemAddToCart(tItem, db);


            if (ujlista)
            {
                var self = selectorBase.parents('.podor-product').find('.kiszereles-darabszam-select-kont');
            } else if (selectMode == 'szett') {
                var self = selectorBase.parents('.podor-product').find('.kezdoszett-items-list');
            } else {
                var self = selectorBase.parents('.podor-product').find('.selectors-cont');
            }


            var imgclone = $(el).clone()
            .addClass('shrink')
            .offset({top: $(el).offset().top, left: $(el).offset().left})
            .css({'opacity': '0.5', 'position': 'absolute', 'overflow': 'hidden', 'z-index': '1000'})
            .appendTo($('body'));

            imgclone.animate({
                // 'width':0,
                // 'height':0,
                'top': cart.offset().top + 10,
                'left': cart.offset().left + 30
            }, 400, 'swing', () => {
                imgclone.remove();
            });





            $('.webshop-button-d2').addClass('changed');

            $.post('/kosar/ad', datas, (res) => {

                // if ($(el).parents('.pontert-megvasarolom').length > 0)
                // {
                //     var aktkat = $('.webshop-termek-list-kont.static').data('aktkat');
                //     var kategoria_kezi_id = $('.webshop-termek-list-kont.static').data('kategoria_kezi_id');

                //     if (WebshopListaSzuresStatic.timer)
                //     {
                //         clearTimeout(WebshopListaSzuresStatic.timer);
                //     }

                //     WebshopListaSzuresStatic.timer = setTimeout(() => {
                //         $('.folderbykateg-items').find('.kategleadhtml-kont#kateg'+kategoria_kezi_id).removeClass('hide');
                //         $('.filter-text-clear').addClass('hide');

                //         WebshopListaSzuresStatic.getList(aktkat, kategoria_kezi_id)
                //     }, 1000);
                // }


                // if (res.nincs_eleg_pont) {

                //     sidebarDisable = true;
                //     if ($('.product-details').length > 0)
                //     {
                //         $(el).parents('.pontert-megvasarolom').find('.no-points').removeClass('d-none');
                //         setTimeout(() => {
                //             $(el).parents('.pontert-megvasarolom').find('.no-points').addClass('d-none');
                //         }, 3000);
                //     } else {
                //         $(el).parents('.prices-kont').find('.no-points').removeClass('d-none');
                //         setTimeout(() => {
                //             $(el).parents('.prices-kont').find('.no-points').addClass('d-none');
                //         }, 3000);
                //     }
                // } else
                {
                    $('.webshop-button-d2 .cart-num').text(res.kos.allproduct);

                    $('.header.v2 .flying-cart, .header.v2 .header-navigation-right-tools .tools .shop').addClass('zoomzoom');
                    setTimeout(() => {
                        $('.header.v2 .flying-cart, .header.v2 .header-navigation-right-tools .tools .shop').removeClass('zoomzoom');
                    }, 1000);

                    //$('.header .tools .shop .amount').text(res.kos.allproduct);
                    $('#kosarlink1 .amount, #kosarlink2 .amount, .header .tools .shop .amount').each((ind, el) => {
                        $(el).text(res.kos.allproduct);
                        if (+res.kos.allproduct > 9) {
                            $(el).addClass('wider');
                        }
                    });


                    setTimeout(() => {
                        if (ujlista) {
                            selectorBase.find('input:text').val('1');
                            selectorBase.find('.kiszerelesek-kont a:first').trigger('click');
                        } else {
                            selectorBase.find('select[name^="db_"]:first').val('0').trigger('change');
                        }
                    }, 400);


                    $('#kosarlink1, #kosarlink2, #kosarlink3').attr('href', kosarShopURL);

                    // datas['res'] = res;

                    datas['debug'] = 1;

                    datas['posta_ingyenlimit'] = $('[name="posta_ingyenlimit"]').val() != "" ? $('[name="posta_ingyenlimit"]').val() : postaIngyenlimit;

                    //window.location.reload()
                    // Kosar.loadIngyenlimit(datas);
                    Kosar.saveKosarToBrowser();
                }
            });

            setTimeout(() => {
                $('.webshop-button-d2').removeClass('changed');


                // if (window.location.href.indexOf('ujfelugro') != -1) {
                if (
                    $("html").data('locale') == 'hu_HU'
                    || $("html").data('locale') == 'de_DE'
                    || $("html").data('locale') == 'sl_SI'
                    || window.location.href.indexOf('ujfelugro') != -1
                ) {
                    if (!sidebarDisable) {
                        Kosar.showSidePanel();
                    }

                } else {
                    Kosar.kosarFelugro = true;
                    if (mode == 'upsale')
                    {
                        $('.termekadatlap-felugro-kont').empty();
                        $('<div>').addClass('wait-datas').appendTo($('.termekadatlap-felugro-kont'));
                        Kosar.loadSelectdialog(datas);
                    } else {
                        Kosar.showSelectdialog(datas);
                    }
                }


            }, 1100);


        } else {

            selectorBase.addClass('shake-shake');
            setTimeout(() => {
                selectorBase.removeClass('shake-shake');
            }, 1100);
        }

        return false;
    }

    ajandekutalvanyErtekSzorzo(sel, parentclass)
    {
        if (!parentclass)
        {
            var parentclass = '.podor-product';
        }
        var ujertek = $(sel).val(),
        ujertek_html = $(sel).find('option[value='+ujertek+']').data('price_html'),
        pricefield = $(sel).parents(parentclass).find('.klub-price span');

        pricefield.html(ujertek_html);

        if ($('[name="akt_termek_ar"]').length > 0)
        {
            console.log('3');
            $('[name="akt_termek_ar"]').val(ujertek);
        }

        return false;
    }

    loadCarouselData(termekoldal_termek_shop_id, kateg, loaddirect)
    {
        $('.productslider.productcategory').empty();
        $('<div>').addClass('wait-datas').appendTo($('.productslider.productcategory'));

        var item_spectpl = "v4";
        if (typeof listitemSpectpl != 'undefined' && listitemSpectpl != "")
        {
            item_spectpl = listitemSpectpl;
        }

        $.get('/index.php/termekadatlap/carouseldata', {termekoldal_termek_shop_id: termekoldal_termek_shop_id, loaddirect: loaddirect, item_spectpl: item_spectpl}, (res) => {
            $('.productslider.productcategory').empty().append(res);

            // $('#productslider').slick({
            //     slideToShow: 1,
            //     slideToScroll: 1,
            //     variableWidth: false,
            //     prevArrow: '<span class="podor-arrow-left"></span>',
            //     nextArrow: '<span class="podor-arrow-right"></span>',
            //     responsive: [
            //         {
            //             breakpoint: 800,
            //             settings: {
            //                 arrows:false,
            //             }
            //         }
            //     ]
            // });
        }, 'html');
    }

    phUpSlide()
    {
        $("input[type=text], input[type=password], textarea").each((i, inp) => {

            if (!$(inp).hasClass('no-fancy-placeholder') && !$(inp).parents('form').hasClass('wpwl-form'))
            {
                var ph = $(inp).attr('placeholder');

                if (ph != "")
                {
                    $(inp).parent().css('position', 'relative');
                    var plah = $('<div>')
                        .addClass('placeholder-text').text(ph)
                        .on("click", (e) => {
                            $(e.currentTarget).parent().find('input').trigger('focus');
                        })
                        .prependTo($(inp).parent());

                    $(inp).attr('placeholder', '');

                    $(inp).on("keyup", (e) => {

                        if ($(e.currentTarget).val() != '')
                        {
                            $(e.currentTarget).parent().find('.placeholder-text').addClass('smallest');
                        } else {
                            $(e.currentTarget).parent().find('.placeholder-text:not(.static)').removeClass('smallest');
                        }
                    })
                        .on("focus", (e) => {
                            if ($(e.currentTarget).val() == '')
                            {
                                $(e.currentTarget).parent().find('.placeholder-text').addClass('smallest');
                            }
                        })
                        .on("blur", (e) => {
                            if ($(e.currentTarget).val() == '')
                            {
                                $(e.currentTarget).parent().find('.placeholder-text:not(.static)').removeClass('smallest');
                            }
                        });
                    if (!$(inp).hasClass('no-keyup-trigger'))
                    {
                        $(inp).trigger('keyup');
                    } else {
                        if ($(inp).hasClass('fire-placeholder'))
                        {
                            if ($(e.currentTarget).val() != '')
                            {
                                $(e.currentTarget).parent().find('.placeholder-text').addClass('smallest');
                            }
                        }
                    }
                }
            }
        });
    }

    maxHeighSeflista()
    {
        this.maxSefLista = 0;
        this.seflistablokkdivs.css('min-height', '0');

        $.each(this.seflistablokkdivs, (indx, el) => {
            this.maxSefLista = Math.max(this.maxSefLista, $(el).height());
        });

        this.seflistablokkdivs.css('min-height', (this.maxSefLista + 10)+'px');
    }

    maxHeighKatelista()
    {
        var maxKategLista = 0;
        var kateglistablokkdivs = $(".productcategory .productlist-category .li-product .podor-product");


        kateglistablokkdivs.css('min-height', '0');

        $.each(kateglistablokkdivs, (indx, el) => {
            maxKategLista = Math.max(maxKategLista, $(el).height());
        });

        kateglistablokkdivs.css('min-height', (maxKategLista + 30)+'px');
    }


    maxWKatch()
    {
        // var omw = $('.webshop-termek-list-kont .kategchooser-kont').css('maxWidth');
        $('.webshop-termek-list-kont.v2 .kategchooser-kont').css('maxWidth', 'auto');
        let kcOriWidth = $('.webshop-termek-list-kont.v2 .kategchooser-kont').width();
        if (window.innerWidth > 1100)
        {
            kcOriWidth = 'auto';
        }
        // $('.webshop-termek-list-kont .kategchooser-kont').css('maxWidth', omw);
    }

    newMenuInit()
    {
        $('.newmenu .navi-main-items .navmenuitem a').on("click", (e) => {
            if ($(e.currentTarget).attr('href') == '#')
            {
                e.preventDefault();
            }
            var targetKateg = $(e.currentTarget).data('sublevel-link');
            if (typeof targetKateg != "undefined")
            {
                if ($('body').hasClass('sticky-menu'))
                {
                    $('body').removeClass('sticky-menu');
                    $('html, body').scrollTop(0);
                } else {
                    $('body').addClass('sticky-menu');
                }
                var kategId = targetKateg.replace("fokateg_", "");

                $('.newmenu .navi-main-items .navmenuitem').removeClass('aktiv');
                $(e.currentTarget).parent().addClass('aktiv');

                var leftpoz = ($(e.currentTarget).width() / 2) + $(e.currentTarget).position().left;
                leftpoz -= 20;
                $(e.currentTarget).parents('.main-items-kont').find('.arr').css('left', leftpoz+'px');


                $('.navi-sub-items .sub-items-kont').addClass('hide');
                $('.navi-sub-items .sub-items-kont#'+targetKateg).removeClass('hide');

                $('.subitem-panel-kont').addClass('hide');
                $('.subitem-panel-kont .subitem-body').addClass('hide');
                $('.subitem-panel-kont').find('.arr-sub').css('left', '-10000 px');

                $('.subitem-panel-kont').removeClass('angebote-panel');
                if (targetKateg == 'fokateg_05')
                {
                    $('.subitem-panel-kont').removeClass('hide');
                    $('.subitem-panel-kont .subitem-body').addClass('hide');
                    $('.subitem-panel-kont .subitem-body#angebote_01').removeClass('hide');
                    $('.subitem-panel-kont').addClass('angebote-panel');
                    $('.subitem-panel-kont').find('.bottom-linkrow').addClass('hide');
                    $('.subitem-panel-kont').find('.arr-sub').addClass('hide');
                }

                /*
                var clicked = false;
                $('.navi-sub-items .sub-items-kont#'+targetKateg+' a').each((e) => {

                    if (!clicked && typeof $(e.currentTarget).data('directlink') == 'undefined')
                    {
                        $(e.currentTarget).trigger('click');
                        clicked = true;
                    }
                });
                */

                /// új termékek menü
                if (kategId == '01' && $('.row.termekekmenu-kont').length > 0 && !$(e.currentTarget).parent().hasClass('coolmetic'))
                {
                    if ($('.row.termekekmenu-kont .menupanel-left').length == 0)
                    {
                        var theBtn = $(e.currentTarget);
                        theBtn.parent().addClass('wait4it');
                        $.get('/index.php/header/getmenu', (menuContent) => {
                            theBtn.parent().removeClass('wait4it');
                            $('.row.termekekmenu-kont').html(menuContent);
                            menuTermekekContentEvents();
                            buildMobileMenuv2();
                            $(e.currentTarget).toggleClass('opened');
                            $('.row.termekekmenu-kont').toggleClass('hide');
                            if ($('.row.termekekmenu-kont').hasClass('hide'))
                            {
                                $('body').addClass('sticky-menu');
                            }
                        });
                    } else {
                        $(e.currentTarget).toggleClass('opened');
                        $('.row.termekekmenu-kont').toggleClass('hide');
                        if ($('.row.termekekmenu-kont').hasClass('hide'))
                        {
                            $('body').addClass('sticky-menu');
                        }
                    }
                }
            }
        });

        // menu 2024
        $('header .menu a').on("click", (e) => {
            var targetKateg = $(e.currentTarget).data('sublevel-link');
            if (typeof targetKateg != "undefined")
                {
                e.preventDefault();
                if (targetKateg == 'fokateg_05')
                {
                    if ($('body').hasClass('sticky-menu'))
                        {
                            $('body').removeClass('sticky-menu');
                            $('html, body').scrollTop(0);
                        } else {
                            $('body').addClass('sticky-menu');
                    }

                    $('.subitem-panel-kont').toggleClass('hide');
                    $('.subitem-panel-kont .subitem-body#angebote_01').removeClass('hide');
                    $('.subitem-panel-kont').addClass('angebote-panel');
                }
            }
        });

        $('.navi-sub-items .sub-items-kont a').each((i, el) => {

            $(el).on("click", (e) => {
                if (typeof $(e.currentTarget).data('directlink') == 'undefined')
                {
                    e.preventDefault();

                    $('.navi-sub-items .sub-items-kont a').removeClass('active');
                    $(e.currentTarget).addClass('active');


                    if ($('.subitem-panel-kont').hasClass('hide'))
                    {
                        $('.subitem-panel-kont').removeClass('hide');
                    }

                    var subpanel = $(e.currentTarget).data('subpanel-id');

                    if (typeof subpanel != 'undefined')
                    {

                        $('.subitem-panel-kont .subitem-body').addClass('hide');

                        if (new String(subpanel).indexOf('recept_') < 0)
                        {

                            $('.subitem-panel-kont .subitem-body#body_'+subpanel).removeClass('hide');

                            var kategUrl = $('.subitem-panel-kont .subitem-body#body_'+subpanel).data('kateglink');
                            $('.subitem-panel-kont').find('.bottom-linkrow a').attr("href", kategUrl);

                        } else if (new String(subpanel).indexOf('angebote_') > -1) {

                            $('.subitem-panel-kont .subitem-body#angebote_'+subpanel).removeClass('hide');

                        } else {

                            subpanel = new String(subpanel).replace('recept_', '');

                            $('.subitem-panel-kont .subitem-body#recept_'+subpanel).removeClass('hide');

                            $('.subitem-panel-kont').find('.bottom-linkrow').addClass('hide');

                        }

                        var leftpoz = ($(e.currentTarget).width() / 2) + $(e.currentTarget).position().left;
                        $('.subitem-panel-kont').find('.arr-sub').removeClass('hide');
                        $('.subitem-panel-kont').find('.arr-sub').css('left', leftpoz+'px');
                    }
                }

            });
        });

        if ($('.row.termekekmenu-kont').length > 0 && !$('.header.v2 span.termekekbutton a').hasClass('coolmetic'))
        {
            $('.row.termekekmenu-kont .items-kont a').on('click', (e) => {
                if (typeof $(e.currentTarget).data('directlink') == 'undefined')
                {
                    e.preventDefault();

                    var subpanel = $(e.currentTarget).data('subpanel-id');
                    if (typeof subpanel != 'undefined')
                    {

                        $('.row.termekekmenu-kont .subitem-body').addClass('hide');

                        $('.row.termekekmenu-kont .subitem-body#body_'+subpanel).removeClass('hide');

                        var kategUrl = $('.row.termekekmenu-kont .subitem-body#body_'+subpanel).data('kateglink');
                        $('.subitem-panel-kont').find('.bottom-linkrow a').attr("href", kategUrl);

                    }

                    $('.row.termekekmenu-kont .items-kont a').removeClass('opened');
                    $(e.currentTarget).addClass('opened');
                }
            });

            $('.row.termekekmenu-kont .filter-kont #termekmenu_csakbio_filter').on('click', (e) => {
                var ch = $(e.currentTarget);

                $('.row.termekekmenu-kont .panels-kont .subitem-body ul').each((i, ule) => {
                    $(ule).find('li:not(.bio)').toggleClass('hide', ch.is(':checked'));

                    $(ule).parent().toggleClass('hide', $(ule).find('li:not(.hide)').length == 0);
                });
            });


        }

        setTimeout(() => {
            $('.newmenu:not(.v2) .navi-main-items .navmenuitem a:first').trigger('click');
        }, 100);

        $('.navi-main-items, .navikont').on('mouseenter', (e) => {
            var newTarget = e.toElement || e.relatedTarget;

            if (!$(newTarget).hasClass('subitem-panel-kont'))
            {
                $('.subitem-panel-kont').addClass('hide');
                $('.navi-sub-items .sub-items-kont a').removeClass('active');
            }
        });

        $('.subitem-panel-kont').on('mouseleave', (e) => {
            var newTarget = e.toElement || e.relatedTarget;

            if (
                !$(newTarget).hasClass('bottom-linkrow') &&
                !$(newTarget).hasClass('subitem-panel-kont') &&
                !$(newTarget).hasClass('navi-sub-items')
            ) {
                $(e.currentTarget).addClass('hide');
                $('.navi-sub-items .sub-items-kont a').removeClass('active');
            }
        });

        $('.lenyilo-reg-area').on('mouseleave', (e) => {
            // $(this).addClass('hide');
            // $('.header .navikont .lenyilo-reg-link a').removeClass('active');
        });

        $('.lenyilo-reg-area .regisztracios-dobozok.reg-v2 .doboz-item.dobozid-ceges').remove();


        /// új termékek menü
        if ($('.row.termekekmenu-kont').length > 0 && $('.header.v2 .termekekmenu-kont .panels-kont .close-me').length == 0)
        {
            var closeMe = $('<a>');
            closeMe.addClass('close-me').attr('href', '');
            closeMe.on('click touch', (e) => {
                e.preventDefault();
                $('.header.v2 span.termekekbutton a').removeClass('opened');
                $('.row.termekekmenu-kont').addClass('hide');
                $('body').addClass('sticky-menu');
            });

            $('.header.v2 .termekekmenu-kont .panels-kont').append(closeMe);
        }

        $(document).on('mouseup', (e) => {
            if (!$('.subitem-body').is(e.target) && $('.subitem-body').has(e.target).length === 0)
            {
                $('.subitem-panel-kont').addClass('hide');
                $('.navi-sub-items .sub-items-kont a').removeClass('active');
            }

            if (!$('.lenyilo-reg-area').is(e.target) && $('.lenyilo-reg-area').has(e.target).length === 0)
            {
                $('.lenyilo-reg-area').addClass('hide');
                $('.header .navikont .lenyilo-reg-link a').removeClass('active');
            }

            if (!$('.header.v2 .termekekmenu-kont').is(e.target) && $('.header.v2 .termekekmenu-kont').has(e.target).length === 0)
            {
                if (!$('.header.v2 .navi-main-items span.termekekbutton a').is(e.target))
                {
                    $('.header.v2 .termekekmenu-kont').addClass('hide');
                    $('body').addClass('sticky-menu');
                    $('.header.v2 .navi-main-items span.termekekbutton a').removeClass('opened');
                }
            }
        });

        if ($("html").data('locale') == 'en_US')
        {
            if ($(".angebotemenu").find("a").length == 0)
            {
                $("[data-sublevel-link=fokateg_05]").parent().hide();
            }
        }

    }

    menuTermekekInit()
    {
        $('header .termekek-wrapper').on('click', (e) => {
            e.preventDefault();
            e.stopPropagation();

            if (
                $("html").data('locale') == 'hu_HU'
                || $("html").data('locale') == 'de_DE'
                || $("html").data('locale') == 'en_US'
                || $("html").data('locale') == 'en_AU'
                || window.location.href.indexOf('design2024') != -1
            )
            {
                if ($('body').hasClass('scroll-off')) {
                    $('body').removeClass('scroll-off');
                } else {
                    $('body').addClass('scroll-off');
                    $('html, body').scrollTop(0);
                }

            } else {

                if ($('body').hasClass('sticky-menu'))
                {
                    $('body').removeClass('sticky-menu');
                    $('html, body').scrollTop(0);
                } else {
                    $('body').addClass('sticky-menu');
                }
            }


            $('header .termekek-wrapper').toggleClass('active');

            if (!$('header .termekek-wrapper').hasClass('active'))
            {
                $('html').css('overflow-y', 'auto');
            }

            MobileMenu2024.initTermekbuttonEvents();
        });

        MobileMenu2024.initpanelButtonEvents();

        $(document).on('click', (e) => {
            if (!$(e.target).closest('header .termekek-wrapper, header.termekmenu-kont .panels-kont').length) {
                if (!this.isMobile())
                {
                    $('header .termekek-wrapper').removeClass('active');
                    $('header.termekmenu-kont').addClass('d-none');

                    if (
                        $("html").data('locale') == 'hu_HU'
                        || $("html").data('locale') == 'en_AU'
                        || $("html").data('locale') == 'en_US'
                        || window.location.href.indexOf('design2024') != -1
                    ) {
                        $('body').removeClass('scroll-off');
                    }
                }
            }


        });

        $('header.termekmenu-kont .items-kont a').on('click', (e) => {
            if (typeof $(e.currentTarget).data('directlink') == 'undefined')
            {
                e.preventDefault();

                var subpanel = $(e.currentTarget).data('subpanel-id');
                if (typeof subpanel != 'undefined')
                {

                    $('header.termekmenu-kont .subitem-body').addClass('d-none');

                    $('header.termekmenu-kont .subitem-body#body_'+subpanel).removeClass('d-none');

                    var kategUrl = $('header.termekmenu-kont .subitem-body#body_'+subpanel).data('kateglink');
                    $('.subitem-panel-kont').find('.bottom-linkrow a').attr("href", kategUrl);

                }

                $('header.termekmenu-kont .items-kont a').removeClass('opened');
                $(e.currentTarget).addClass('opened');
            }
        });

        $('header.termekmenu-kont .filter-kont #termekmenu_csakbio_filter').on('click', (e) => {
            var ch = $(e.currentTarget);

            ch.parent().toggleClass('active', ch.is(':checked'));

            $('header.termekmenu-kont .panels-kont .subitem-body ul').each((i, ule) => {
                $(ule).find('li:not(.bio)').toggleClass('d-none', ch.is(':checked'));

                $(ule).parent().toggleClass('d-none', $(ule).find('li:not(.d-none)').length == 0);
            });
        });

        $('header.termekmenu-kont .close-me').on('click', (e) => {
            e.preventDefault();
            $('header .termekek-wrapper').removeClass('active');
            $('header.termekmenu-kont').addClass('d-none');
        });

    }

    menuTermekekContentEvents()
    {

        /// új termékek menü
        if ($('.row.termekekmenu-kont').length > 0 && $('.header.v2 .termekekmenu-kont .panels-kont .close-me').length == 0)
        {
            var closeMe = $('<a>');
            closeMe.addClass('close-me').attr('href', '');
            closeMe.on('click touch', (e) => {
                e.preventDefault();
                $('.header.v2 span.termekekbutton a').removeClass('opened');
                $('.row.termekekmenu-kont').addClass('hide');
                $('body').addClass('sticky-menu');
            });

            $('.header.v2 .termekekmenu-kont .panels-kont').append(closeMe);
        }

        $(document).on('mouseup', (e) => {
            if (!$('.subitem-body').is(e.target) && $('.subitem-body').has(e.target).length === 0)
            {
                $('.subitem-panel-kont').addClass('hide');
                $('.navi-sub-items .sub-items-kont a').removeClass('active');
            }

            if (!$('.lenyilo-reg-area').is(e.target) && $('.lenyilo-reg-area').has(e.target).length === 0)
            {
                $('.lenyilo-reg-area').addClass('hide');
                $('.header .navikont .lenyilo-reg-link a').removeClass('active');
            }

            if (!$('.header.v2 .termekekmenu-kont').is(e.target) && $('.header.v2 .termekekmenu-kont').has(e.target).length === 0)
            {
                if (!$('.header.v2 .navi-main-items span.termekekbutton a').is(e.target))
                {
                    $('.header.v2 .termekekmenu-kont').addClass('hide');
                    $('body').addClass('sticky-menu');
                    $('.header.v2 .navi-main-items span.termekekbutton a').removeClass('opened');
                }
            }
        });


        setTimeout(() => {
            $('.newmenu:not(.v2) .navi-main-items .navmenuitem a:first').trigger('click');
        }, 100);

        $('.navi-main-items, .navikont').on('mouseenter', (e) => {
            var newTarget = e.toElement || e.relatedTarget;

            if (!$(newTarget).hasClass('subitem-panel-kont'))
            {
                $('.subitem-panel-kont').addClass('hide');
                $('.navi-sub-items .sub-items-kont a').removeClass('active');
            }
        });

        $('.subitem-panel-kont').on('mouseleave', (e) => {
            var newTarget = e.toElement || e.relatedTarget;

            if (
                !$(newTarget).hasClass('bottom-linkrow') &&
                !$(newTarget).hasClass('subitem-panel-kont') &&
                !$(newTarget).hasClass('navi-sub-items')
            ) {
                $(e.currentTarget).addClass('hide');
                $('.navi-sub-items .sub-items-kont a').removeClass('active');
            }
        });

        if ($('.row.termekekmenu-kont').length > 0 && !$('.header.v2 span.termekekbutton a').hasClass('coolmetic'))
        {
            $('.row.termekekmenu-kont .items-kont a').on('click', (e) => {
                if (typeof $(e.currentTarget).data('directlink') == 'undefined')
                {
                    e.preventDefault();

                    var subpanel = $(e.currentTarget).data('subpanel-id');
                    if (typeof subpanel != 'undefined')
                    {

                        $('.row.termekekmenu-kont .subitem-body').addClass('hide');

                        $('.row.termekekmenu-kont .subitem-body#body_'+subpanel).removeClass('hide');

                        var kategUrl = $('.row.termekekmenu-kont .subitem-body#body_'+subpanel).data('kateglink');
                        $('.subitem-panel-kont').find('.bottom-linkrow a').attr("href", kategUrl);

                    }

                    $('.row.termekekmenu-kont .items-kont a').removeClass('opened');
                    $(e.currentTarget).addClass('opened');
                }
            });

            $('.row.termekekmenu-kont .filter-kont #termekmenu_csakbio_filter').on('click', (e) => {
                var ch = $(e.currentTarget);

                $('.row.termekekmenu-kont .panels-kont .subitem-body ul').each((i, ule) => {
                    $(ule).find('li:not(.bio)').toggleClass('hide', ch.is(':checked'));

                    $(ule).parent().toggleClass('hide', $(ule).find('li:not(.hide)').length == 0);
                });
            });


        }

    }

    buildMobileMenu()
    {
        // mobile-menu-kont

        return false;
        $('.navi-main-items .navmenuitem:not(.mobile-ex) a').each((i, lnk) => {

            var topLevelKont = $('<div>');
            topLevelKont.addClass('toplevel');

            var topLevelLink = $('<a>');

            topLevelLink.attr('href', $(lnk).attr('href'));
            if (typeof $(lnk).data('directlink') != 'undefined')
            {
                topLevelLink.data('directlink', 1);
            }

            if ($(lnk).hasClass('kozmetika-protected'))
            {
                topLevelLink.addClass('kozmetika-protected');
            }

            if (typeof $(lnk).data('mobile_directlink') != 'undefined')
            {
                topLevelLink.data('directlink', 1);
                topLevelLink.attr('href', $(lnk).data('mobile_directlink'));
            }

            topLevelLink.text($(lnk).text());

            if (typeof $(lnk).data('hirlevellink') != "undefined")
            {
                $(topLevelLink).on('click touch', () => {
                    newMenuHirlevelClick();
                });
            }

            if (typeof $(lnk).data('sublevel-link') != "undefined")
            {
                if (typeof $(lnk).data('mobile_directlink') == 'undefined')
                {
                    $('<a>').addClass('nclose').appendTo(topLevelLink);
                }
            }

            topLevelLink.on("click touch", (e) => {

                if (typeof $(e.currentTarget).data('directlink') == 'undefined')
                {
                    e.preventDefault();
                    if ($(e.currentTarget).next().hasClass('closed'))
                    {
                        $('.mobile-menu-kont .sublevel').addClass('closed');
                        $(e.currentTarget).next().removeClass('closed');
                        $(e.currentTarget).find('.nclose').addClass('flip');
                    } else {
                        $(e.currentTarget).find('.nclose').removeClass('flip');
                        $(e.currentTarget).next().addClass('closed');
                    }
                }
            });

            if (typeof $(lnk).data('sublevel-link') != "undefined")
            {

                var subitemsLevels = $('.navi-sub-items .sub-items-kont#'+$(lnk).data('sublevel-link'));

                var subitemsKont = $('<div>').addClass('sublevel level-1 closed');

                subitemsLevels.find('a').each((i2, lv1) => {

                    var subLevelLink = $('<a>');

                    subLevelLink.attr('href', $(lv1).attr('href'));
                    if (typeof $(lv1).data('directlink') != 'undefined')
                    {
                        subLevelLink.data('directlink', 1);
                    }

                    subLevelLink.text($(lv1).text());
                    subLevelLink.on("click touch", (e) => {
                        if (typeof $(e.currentTarget).data('directlink') == 'undefined')
                        {
                            e.preventDefault();
                            if ($(e.currentTarget).next().hasClass('closed'))
                            {
                                $(e.currentTarget).parents('.sublevel.level-1').find('.level-2').addClass('closed');
                                $(e.currentTarget).next().removeClass('closed');
                            } else {
                                $(e.currentTarget).next().addClass('closed');
                            }
                        }
                    });
                    subLevelLink.appendTo(subitemsKont);

                    var subpanel = $(lv1).data('subpanel-id');

                    var subitemsLv2Kont = $('<div>').addClass('sublevel level-2 closed');
                    var subitemLv2Links;

                    if (new String(subpanel).indexOf('recept_') < 0)
                    {
                        subitemLv2Links = $('.subitem-panel-kont .subitem-body#body_'+subpanel);
                    } else if (new String(subpanel).indexOf('angebote_') > -1) {
                        subitemLv2Links = $('.subitem-panel-kont .subitem-body#angebote_'+subpanel);
                    } else {
                        subitemLv2Links = $('.subitem-panel-kont .subitem-body#'+subpanel);
                    }


                    $(subitemLv2Links).find('fieldset:not(.exclude-menugen)').each((i3, fields) => {
                        if ($(fields).find('legend').length > 0)
                        {
                            $('<div>').text($(fields).find('legend').text()).addClass('subkateglabel').appendTo(subitemsLv2Kont);
                        }
                        $(fields).find('a').each((i4, lnk2) => {
                            $(lnk2).clone().appendTo(subitemsLv2Kont);
                        });
                    });

                    subitemsLv2Kont.appendTo(subitemsKont);

                });

                subitemsKont.appendTo(topLevelKont);


            }

            topLevelKont.appendTo('.mobile-menu-kont');
        });

    }

    buildMobileMenuv2()
    {
        // mobile-menu-kont

        var webshopButton = {}, termekbutton = {};
        var presavedLinks = [];
        $('.mobile-menu-kont .toplevel').each((i, lnk) => {
            presavedLinks.push({
                'link': $(lnk).find('a').attr('href'),
                'text': $(lnk).find('a').text(),
                'class': $(lnk).find('a').attr('class')
            });
        });

        $('.mobile-menu-kont .toplevel').remove();

        $('.navi-main-items .navmenuitem:not(.mobile-ex) a').each((i, lnk) => {

            var topLevelKont = $('<div>');
            topLevelKont.addClass('toplevel');

            var topLevelLink = $('<a>');

            topLevelLink.attr('href', $(lnk).attr('href'));
            if (typeof $(lnk).data('directlink') != 'undefined')
            {
                topLevelLink.data('directlink', 1);
            }

            if ($(lnk).hasClass('kozmetika-protected'))
            {
                topLevelLink.addClass('kozmetika-protected');
            }

            if (typeof $(lnk).data('mobile_directlink') != 'undefined'
                && $(lnk).data('sublevel-link') != 'fokateg_05'
            )
            {
                topLevelLink.data('directlink', 1);
                topLevelLink.attr('href', $(lnk).data('mobile_directlink'));
            }

            topLevelLink.text($(lnk).text());

            if (typeof $(lnk).data('hirlevellink') != "undefined")
            {
                $(topLevelLink).on('click touch', () => {
                    newMenuHirlevelClick();
                });
            }

            if (typeof $(lnk).data('sublevel-link') != "undefined")
            {
                if (typeof $(lnk).data('mobile_directlink') == 'undefined')
                {
                    $('<a>').addClass('nclose').appendTo(topLevelLink);
                }
            }

            topLevelLink.on("click touch", (e) => {

                if (typeof $(e.currentTarget).data('directlink') == 'undefined')
                {
                    e.preventDefault();
                    if ($(e.currentTarget).next().hasClass('closed'))
                    {
                        $('.mobile-menu-kont .sublevel').addClass('closed');
                        $(e.currentTarget).next().removeClass('closed');
                        $(e.currentTarget).find('.nclose').addClass('flip');
                    } else {
                        $(e.currentTarget).find('.nclose').removeClass('flip');
                        $(e.currentTarget).next().addClass('closed');
                    }
                }
            });

            topLevelLink.appendTo(topLevelKont);

            if (
                typeof $(lnk).data('sublevel-link') != "undefined"
                && $(lnk).data('sublevel-link') != 'fokateg_05'
            )
            {

                var subitemsLevels = $('.termekekmenu-kont .panels-kont .menupanel-left .items-kont');

                var subitemsKont = $('<div>').addClass('sublevel level-1 closed');

                subitemsLevels.find('a').each((i2, lv1) => {

                    var subLevelLink = $('<a>');

                    subLevelLink.attr('href', $(lv1).attr('href'));
                    if (typeof $(lv1).data('directlink') != 'undefined')
                    {
                        subLevelLink.data('directlink', 1);
                    }

                    var lvl1text = $(lv1).html();
                    lvl1text.replace(/<br\s*[\/]?>/gi, "\n");

                    subLevelLink.html(lvl1text);
                    subLevelLink.on("click touch", (e) => {
                        if (typeof $(e.currentTarget).data('directlink') == 'undefined')
                        {
                            e.preventDefault();
                            if ($(e.currentTarget).next().hasClass('closed'))
                            {
                                $(e.currentTarget).parents('.sublevel.level-1').find('.level-2').addClass('closed');
                                $(e.currentTarget).next().removeClass('closed');
                            } else {
                                $(e.currentTarget).next().addClass('closed');
                            }
                        }
                    });
                    subLevelLink.appendTo(subitemsKont);

                    var subpanel = $(lv1).data('subpanel-id');

                    var subitemsLv2Kont = $('<div>').addClass('sublevel level-2 closed');
                    var subitemLv2Links;

                    subitemLv2Links = $('.termekekmenu-kont .menupanel-right .subitem-body#body_'+subpanel);


                    $(subitemLv2Links).find('fieldset:not(.exclude-menugen)').each((i3, fields) => {
                        if ($(fields).find('legend').length > 0)
                        {
                            $('<div>').text($(fields).find('legend').text()).addClass('subkateglabel').appendTo(subitemsLv2Kont);
                        }
                        $(fields).find('a').each((i4, lnk2) => {
                            $(lnk2).clone().appendTo(subitemsLv2Kont);
                        });
                    });

                    subitemsLv2Kont.appendTo(subitemsKont);

                });

                subitemsKont.appendTo(topLevelKont);

            }

            if ($(lnk).data('sublevel-link') == 'fokateg_05')
            {

                let akcioksubitemsKont = $('<div>').addClass('sublevel level-2 akciok closed');


                let akcioksubitemLv2Links;

                akcioksubitemLv2Links = $('.subitem-body#angebote_01');

                $(akcioksubitemLv2Links).find('fieldset:not(.exclude-menugen)').each((i3, fields) => {
                    if ($(fields).find('legend').length > 0)
                    {
                        $('<div>').text($(fields).find('legend').text()).addClass('subkateglabel').appendTo(akcioksubitemsKont);
                    }
                    $(fields).find('a').each((i4, lnk2) => {
                        $(lnk2).clone().appendTo(akcioksubitemsKont);
                    });
                });

                akcioksubitemsKont.appendTo(topLevelKont);

            }


            if ($(lnk).parent().hasClass('termekekbutton') || $(lnk).parent().hasClass('webshop')) {
                if ($(lnk).parent().hasClass('termekekbutton')) {
                    termekbutton = topLevelKont;
                }

                if ($(lnk).parent().hasClass('webshop')) {
                    webshopButton = topLevelKont;
                }
            } else {
                topLevelKont.appendTo('.mobile-menu-kont');
            }

        });

        // presavedLinks hozzáfűzése
        for (var pl in presavedLinks) {
            var prestopLevelKont = $('<div>');
            prestopLevelKont.addClass('toplevel');

            var prestopLevelLink = $('<a>');

            prestopLevelLink.attr('href', presavedLinks[pl].link);
            prestopLevelLink.text(presavedLinks[pl].text);
            prestopLevelLink.addClass(presavedLinks[pl].class);

            prestopLevelLink.appendTo(prestopLevelKont);

            prestopLevelKont.appendTo('.mobile-menu-kont');

        }
        try {
            webshopButton.prependTo('.mobile-menu-kont');
            termekbutton.prependTo('.mobile-menu-kont');
        } catch(e) {}

        $('.header.v2 .navigation .smartphone-service a#kosarlink1').detach().addClass('flying-cart').prependTo('.mobile-nav-toggle-wrap');
        $('.header.v2 .flying-cart .text').remove();
        $('<span>').addClass('cart-plus').appendTo($('.header.v2 .flying-cart'));
    }

    newMenuHirlevelClick(bigoffset)
    {
        if (!bigoffset)
        {
            var bigoffset = false;
        }

        if (bigoffset)
        {
            $("html, body").stop().animate({scrollTop: $('#hirlevelform').offset().top- 300}, '500');
        } else {
            $("html, body").stop().animate({scrollTop: $('#hirlevelform').offset().top - 80}, '500');
        }
        return false;
    }

    updateUjadatlapZoldplecsni()
    {
        if (typeof oldPlecsnik != 'undefined' && $('.nagyzoldplecsni').length > 0)
        {

            $('.nagyzoldplecsni .plecs').addClass('hide');

            var aktPLecsnik = oldPlecsnik.split(',');

            $('.nagyzoldplecsni .plecs').each((i, el) => {

                for (var i in aktPLecsnik)
                {
                    if (aktPLecsnik.hasOwnProperty(i))
                    {
                        if (+aktPLecsnik[i] == +$(el).data('plecsniid'))
                        {
                            $(el).removeClass('hide');
                        }
                    }
                }

            });
        }
    }


    termekoldalTabclick(el) {

        if (!$(el).hasClass('inactivated'))
        {
            var tabKont = $(el).data('tab');

            $(el).blur();

            if (window.innerWidth <= 991) {

                if ($(el).hasClass('aktiv'))
                {
                    $(el).removeClass('aktiv');
                    $(el).parent().find('.leftcontent').addClass('hide');
                } else {
                    $('.product-tabs .tabs a').removeClass('aktiv');
                    $('.product-tabs .tabs .leftcontent').addClass('hide');

                    $(el).addClass('aktiv');
                    $(el).parent().find('.leftcontent').removeClass('hide');

                    $('.product-tabs .tab-kontents .leftcontent').removeClass('hide');
                    $('.product-tabs .tab-kont').addClass('hide');
                    $('.product-tabs #tab-' + tabKont).removeClass('hide');

                    // window.scroll({ top: $(el).parent().find('.leftcontent').position().top - 200, behavior: 'instant' });
                }

            } else
            {

                $('.product-tabs .tabs a').removeClass('aktiv');
                $(el).addClass('aktiv');

                $('.product-tabs .tab-kontents .leftcontent').removeClass('hide');
                $('.product-tabs .tab-kont').addClass('hide');
                $('.product-tabs #tab-' + tabKont).removeClass('hide');


                $('#tab-receptek .imageright').css({
                    'minHeight': $('#tab-receptek .leftcontent').height() + 'px',
                });
            }
        }

        return false;
    }

    termekoldalDescriptionFadeInOut(el)
    {
        $(el).parents('.description-panel').toggleClass('active');

        if ($(el).parents('.description-panel').hasClass('active'))
        {
            $(el).find('span').text($(el).find('span').data('opened-text'));
        } else {
            $(el).find('span').text($(el).find('span').data('closed-text'));
        }

        $(el).blur();
        return false;
    }

    ujadatlaptabsinit()
    {
        var disabledTabs = [];

        if ($('a[data-tab="pwirkung"] + .leftcontent').length > 0) {
            if ("" + $('a[data-tab="pwirkung"] + .leftcontent').text().trim() == "") {
                disabledTabs.push('pwirkung');
            }
        } else {
            if ("" + $('#tab-pwirkung .leftcontent').text().trim() == "") {
                disabledTabs.push('pwirkung');
            }
        }

        if ($('a[data-tab="wirkung"] + .leftcontent').length > 0)
        {
            if ("" + $('a[data-tab="wirkung"] + .leftcontent').text().trim() == "") {
                disabledTabs.push('wirkung');
            }
        } else {
            if ("" + $('#tab-wirkung .leftcontent').text().trim() == "") {
                disabledTabs.push('wirkung');
            }
        }

        var recnu = $('.recipes.products').data('maxreceptnum');
        $('[data-tab="receptek"] span').text(recnu);

        if (recnu == 0)
        {
            disabledTabs.push('receptek');
        } else {

            var firstURl = "", imgs = [];
            $('#tab-receptek .leftcontent a').each((i, a) => {
                var imgU = $(a).data('kepurl');
                if (typeof imgU != 'undefined')
                {
                    if (firstURl == "")
                    {
                        firstURl = imgU;
                    }
                    //preload
                    imgs.push(new Image().src = imgU);
                }

                $(a).on("hover", (e) => {
                    var imgU = $(e.currentTarget).data('kepurl');
                    console.log(imgU);
                    if (typeof imgU != 'undefined')
                    {
                        $('#tab-receptek .imageright').css('backgroundImage', 'url('+imgU+')');
                    }
                });
            });

            if (firstURl != '')
            {
                $('#tab-receptek .imageright').css({
                    'backgroundImage': 'url('+firstURl + ')',
                    'minHeight': $('#tab-receptek .leftcontent').height()+'px',
                });
            }
        }


        if (disabledTabs.length == 4)
        {
            $('.ujadatlap-tabok-kont').addClass('hide');
        } else {
            for (var i in disabledTabs)
            {
                if (disabledTabs.hasOwnProperty(i))
                {
                    $('.product-tabs .tabs a[data-tab="'+disabledTabs[i]+'"]').addClass('inactivated').text('');
                    $('.product-tabs .tabs a[data-tab="'+disabledTabs[i]+'"]').parent().addClass('inactivated-tab');
                    $('#tab-'+disabledTabs[i]).addClass('nocontent');
                }
            }
        }

        $('.product-tabs .tabs a:not(.inactivated):first').addClass('aktiv');
        $('.footer-seals').removeClass('hide');
        $('.product-tabs .tab-kontents .tab-kont:not(.nocontent):first').removeClass('hide');

        if ($('.product-tabs .tabs a:not(.inactivated)').length == 1) {
            $('.product-tabs .tabs-kont').addClass('hide');
        }

    }

    multiPicsSelectorInit()
    {
        if ($(".multipicselector-kont").length > 0 && $("[data-imgnum=1] img").length > 0)
        {
            var img1 = $("[data-imgnum=1] img")[0].currentSrc;
            $('.picselector-kont [data-changer=1]').css('backgroundImage', 'url('+img1+')');

            $('.multipicselector-kont .mainpicture-kont .imgkont').each((i, el) => {
                var imgNum = $(el).data('imgnum');
                var imgsrcp = $("[data-imgnum="+imgNum+"] img")[0].currentSrc;
                $('.picselector-kont [data-changer='+imgNum+']').css('backgroundImage', 'url('+imgsrcp+')');
            });


            /*
            for (var i = 2;i<=6;i++)
            {
                if ($("[data-imgnum="+i+"] picture img").length > 0)
                {
                    var imgsrcp = $("[data-imgnum="+i+"] picture img")[0].currentSrc;
                    $('.picselector-kont [data-changer='+i+']').css('backgroundImage', 'url('+imgsrcp+')');
                }
            }*/

            /*
            setTimeout(() => {

                var img1minH = $("[data-imgnum=1] picture img")[0].height;
                var img2minH = $("[data-imgnum=2] picture img")[0].height;
                var minH = Math.max(img1minH, img2minH);

                $(".mainpicture-kont").css("min-height", minH+"px");
            }, 3000);
            */



            $('.picselector-kont [data-changer]').on('click', (e) => {
                e.preventDefault();

                /*
                var imgnum = $(e.currentTarget).data('changer');
                var kiszid = $(e.currentTarget).data('kiszereles_id');

                $(".mainpicture-kont [data-imgnum]").addClass('noshow');

                $(".mainpicture-kont [data-imgnum="+imgnum+"]").removeClass('noshow');

                $('.picselector-kont [data-changer]').removeClass('active');
                $(e.currentTarget).addClass('active');

                if (typeof kiszid != "undefined" && kiszid != '')
                {
                    ujAdatlapUjarvalaszto.changeKiszerelesEvent($('.cart-ujadatlap .kiszereles-selectors .kiszerelesek-kont a[data-kiszereles_id='+kiszid+']'));
                }*/


            });
        }
    }

    termekadatlapKategScroll(el)
    {
        var bio = $(el).data('bio') == 1 ? '-b' : '';
        var kat = +$(el).data('kategid')+bio;

        kat = kat > 9 ? kat : '0'+kat;

        if ($('.flex-podor-singleproduct-RelatedProducts fieldset.kategoriaid-'+kat).length > 0)
        {
            $("html, body").stop().animate({
                scrollTop: $('.flex-podor-singleproduct-RelatedProducts').offset().top - 40
            }, '150', () => {
                setTimeout(() => {

                    $('.flex-podor-singleproduct-RelatedProducts fieldset.kategoriaid-'+kat+' legend').removeClass('fadeinpout2x').addClass('fadeinpout2x');
                    setTimeout(() => {
                        $('.flex-podor-singleproduct-RelatedProducts fieldset.kategoriaid-'+kat+' legend').removeClass('fadeinpout2x');
                    }, 1000);
                }, 600);
            });
        } else {
            $("html, body").stop().animate({
                scrollTop: $('.flex-podor-singleproduct-RelatedProducts').offset().top - 40
            }, '150');
        }

        return false;
    }

    base64Decode(str) {
        if (typeof window.atob != 'undefined')
        {
            return decodeURIComponent(escape(window.atob(str)));

        } else {
            Base64.decode(str);
        }
    }

    base64Encode(str) {
        if (typeof window.btoa != 'undefined')
        {
            return window.btoa(unescape(encodeURIComponent(str)));
        } else {
            Base64.encode(str);
        }
    }

    kuponreglandingMeghivolinkCopy(el)
    {
        var base = $(el).parents('.meghivolink-kont');
        $('input:text', base).get(0).select();
        document.execCommand("copy");

        setTimeout(() => {
            $('input:text', base).blur();
        }, 1000);

        return false;
    }

    receptadatlapv2atrendezes()
    {

        if (window.innerWidth < 992) {

            $('.receptadatlap2 .ujhozzavalok')
                .detach()
                .insertAfter('.receptadatlap2 .receptsides .receptsides-left .function-items');

            $('.receptadatlap2 .kapcsolodo-recept-lista')
                .detach()
                .insertAfter('.receptadatlap2 .receptsides .receptsides-left .recept-hozaszolasok');
        } else {

            $('.receptadatlap2 .ujhozzavalok')
                .detach()
                .appendTo('.receptadatlap2 .receptsides .receptsides-right');

            $('.receptadatlap2 .kapcsolodo-recept-lista')
                .detach()
                .appendTo('.receptadatlap2 .receptsides .receptsides-right');
        }
    }

    openMennyisegiKedvezmenyekPopUp()
    {
        popupMessageSystem.showWin('');
        $('.pms-message').empty();
        $('<div>').addClass('wait-datas').appendTo($('.pms-message'));

        $.get('/index.php/termekek/mennyisegikedvezmenytablazat', {r: new Date().getTime()}, (res) => {
            if (res != '')
            {
                if (typeof mennyisegitablazat_popup_szoveg != 'undefined')
                {
                    res = res.replace('{popup_szoveg}', base64Decode(mennyisegitablazat_popup_szoveg));
                }
                $('.pms-message').html(res);
            }
        }, 'html');

        return false;
    }

    makeAlias(value) {
        let alias = value.replace(/[&]/gi, "and");
        alias = alias.replace(/[\s|.]+/gi, "_");

        alias = alias.replace(/[Ç|ç|Ć|ć|Č|č|Ĉ|ĉ|Œ|œ]/gi, "c");
        alias = alias.replace(/[Ë|ë|È|è|É|é|Ě|ě|ê|Ē|ē|Ę|ę]/gi, "e");
        alias = alias.replace(/[Đ|đ|Ď|ď|Ð|ð]/gi, "d");
        alias = alias.replace(/[Š|š|Ŝ|ŝ|Ś|ś|Ş|ş|ß]/gi, "s");
        alias = alias.replace(/[Ž|ž|Ź|ź|Ż|ż]/gi, "z");
        alias = alias.replace(/[À|à|Á|á|Æ|æ|Å|å|Ä|ä|Â|â|Ã|ã|Ā|ā|Ą|ą|ª|Ă|ă|¡|ª]/gi, "a");
        alias = alias.replace(/[Í|í|Ï|ï|Î|î|Ĩ|ĩ|Ì|ì|Ī|ī|İ|ı]/gi, "i");
        alias = alias.replace(/[Ò|ò|Ó|ó|Ø|ø|Ö|ö|Õ|õ|Ô|ô|Ő|ő|º|¿|º]/gi, "o");
        alias = alias.replace(/[Ú|ú|Ü|ü|Ů|ů|Ŭ|ŭ|Ù|ù|Û|û|Ú|ù|Ũ|ũ|Ű|ű|Ū|ū]/gi, "u");
        alias = alias.replace(/[Ň|ň|Ņ|ņ|Ń|ń|Ŋ|ŋ|Ñ|ñ]/gi, "n");
        alias = alias.replace(/[Ř|ř|Ŗ|ŗ|Ŕ|ŕ]/gi, "r");
        alias = alias.replace(/[Ť|ť|Ţ|ţ|Ŧ|ŧ]/gi, "t");
        alias = alias.replace(/[Ý|ý|Ÿ|ÿ]/gi, "y");
        alias = alias.replace(/[Ĝ|ĝ|Ģ|ģ|Ğ|ğ]/gi, "g");
        alias = alias.replace(/[Ĥ|ĥ]/gi, "h");
        alias = alias.replace(/[Ĵ|ĵ]/gi, "j");
        alias = alias.replace(/[Þ|þ]/gi, "b");
        alias = alias.replace(/[ĸ|Ķ|ķ]/gi, "k");
        alias = alias.replace(/[Ļ|ļ|Ł|ł|Ĺ|ĺ|Ľ|ľ]/gi, "l");

        alias = alias.replace(/[á|Á|ä|Ä]/gi, "a");
        alias = alias.replace(/[ó|Ó|ő|Ő|ö|Ö]/gi, "o");
        alias = alias.replace(/[ú|Ú|ű|Ű|ü|Ü]/gi, "u");
        alias = alias.replace(/[é|É]/gi, "e");
        alias = alias.replace(/[í|Í]/gi, "i");

        alias = alias.replace(/[^0-9A-Za-z]/gi, "-");

        alias = alias.replace(/[-]{2,}/gi, "-");
        return alias.toLowerCase();
    }

    KuponlandingFormOpenReglink()
    {
        $("html, body").stop().animate({scrollTop: 0}, '100', () => {
            $('.header .navikont .lenyilo-reg-link a').addClass('active');
            $('.header .lenyilo-reg-area').removeClass('hide');
        });
        return false;
    }

    checkVisible(el)
    {
        // Special bonus for those using jQuery
        if (typeof jQuery === "function" && el instanceof jQuery) {
            el = el[0];
        }

        let rect = el.getBoundingClientRect();

        return (
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && /* or $(window).height() */
            rect.right <= (window.innerWidth || document.documentElement.clientWidth) /* or window.innerWidth */
        );
    }


    loadTermekLegkedveltebbCarouselData()
    {
        $('.product-carousel-kont .carousel').empty();
        $('<div>').addClass('wait-datas').appendTo($('.product-carousel-kont .carousel'));

        setTimeout(() => {
            $.get('/index.php/webshoplist_static/gethtml', { limit: 15, kategoria: -2, extra: 'onlyitems', randomorder: 1, t: (new Date().getTime()) }, (res) => {
                var termekoldalCarouselItems = res.html;
                // első három betöltése
                console.log('termekoldalCarouselItems', $(termekoldalCarouselItems).length);
                var first5 = $(termekoldalCarouselItems).slice(0, 5);
                var restItems = $(termekoldalCarouselItems).slice(5);
                console.log('first5', first5);
                console.log('restItems', restItems);

                $('.product-carousel-kont .carousel').empty().append(first5);
                for (var i = 0; i < restItems.length; ++i)
                {
                    $('.product-carousel-kont .carousel').append('<div class="item dummy"></div>');
                }

                $('.product-carousel-kont .carousel').slick({
                    infinite: false,
                    dots: true,
                    slidesToShow: 5,
                    slidesToScroll: 5,
                    adaptiveHeight: true,
                    arrows: true,
                    prevArrow: '<span class="podor-arrow-left"></span>',
                    nextArrow: '<span class="podor-arrow-right"></span>',
                    responsive: [
                        {
                            breakpoint: 991,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1
                            }
                        }],
                });

                $('.product-carousel-kont .carousel').on('beforeChange', (event, slick, currentSlide, nextSlide) => {
                    if (nextSlide == 5)
                    {
                        $('.product-carousel-kont .carousel').slick('slickSetOption', 'infinite', true, true);
                    }
                    var slideLength = slick.$slides.length;
                    for (var ri = 5; ri < slideLength; ++ri)
                    {
                        $('.product-carousel-kont .carousel').find('[data-slick-index=' + ri + ']').html(
                            $($(termekoldalCarouselItems)[ri]).html()
                        );
                    }

                    $('.product-carousel-kont .carousel .item').each((i, tItem) => {
                        $(tItem).find('.video-popup-link').each((i, vidlink) => {
                            $(vidlink).on('click', (e) => {
                                e.preventDefault();
                                termeklistaVideoFelugro.showPopUp(
                                    $(e.currentTarget).attr('href'),
                                    $(e.currentTarget).parents('.podor-product').data('termek_nev')
                                );
                            });
                        });
                    });

                });

                $('.product-carousel-kont .carousel .item').each((i, tItem) => {
                    $(tItem).find('.video-popup-link').each((i, vidlink) => {
                        $(vidlink).on('click', (e) => {
                            e.preventDefault();
                            termeklistaVideoFelugro.showPopUp(
                                $(e.currentTarget).attr('href'),
                                $(e.currentTarget).parents('.podor-product').data('termek_nev')
                            );
                        });
                    });
                });


            });
        }, 1000);
    }

    loadKosarpanelTermekLegkedveltebbCarouselData()
    {
        $('.kosar-panel-footer .kosar-carousel .carousel').empty();
        $('<div>').addClass('wait-datas').appendTo($('.kosar-panel-footer .kosar-carousel .carousel'));

        setTimeout(() => {
            $.get('/index.php/webshoplist_static/gethtml', {limit: 10, kategoria: -2, extra: 'onlyitems', nezet: 'kosarpanel', randomorder: 1, t: (new Date().getTime())}, (res) => {
                $('.kosar-panel-footer .kosar-carousel .carousel').empty().append(res.html);

                $('.kosar-panel-footer .kosar-carousel .carousel').slick({
                    infinite: true,
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    adaptiveHeight: false,
                    arrows: true,
                    prevArrow: '<span class="podor-arrow-left"></span>',
                    nextArrow: '<span class="podor-arrow-right"></span>',
                    responsive: [
                        {
                            breakpoint: 991,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1
                            }
                        }],
                });

                $('.kosar-panel-footer .kosar-carousel .item').each((i, tItem) => {
                    $(tItem).find('.video-popup-link').each((i, vidlink) => {
                        $(vidlink).on('click', (e) => {
                            e.preventDefault();
                            termeklistaVideoFelugro.showPopUp(
                                $(e.currentTarget).attr('href'),
                                $(e.currentTarget).parents('.podor-product').data('termek_nev')
                            );
                        });
                    });
                });

                var fullPanelHeight = $('.kosar-panel-kont').height();
                var termeklistKontHeight = $('.kosar-panel-body').height();
                var termekListHeight = $('.kosar-items-kont').height();
                var footerHeight = $('.kosar-panel-footer').height();
                var termekListNewHeight = fullPanelHeight - footerHeight - (termeklistKontHeight - termekListHeight);

                $('.kosar-items-kont').css('maxHeight', termekListNewHeight + 'px');

            });
        }, 1000);
    }


    email_signup_form_event_init()
    {
        console.log('email_signup_form_event_init');
        $('.email-signup-kont form button:not(.has-event)').on("click", (e) => {

            var error = false;

            $(e.currentTarget).addClass('has-event');
            var baseForm = $(e.currentTarget).parents('form');

            if (typeof shopLoginStatus !== 'undefined' && !shopLoginStatus)
            {
                console.log('email-signup-kont form button click event', $('input:text', baseForm));
                if ($('input:text', baseForm).val() == '')
                {
                    $('input:text', baseForm).addClass('shake-shake');
                    setTimeout(() => {
                        $(' input:text', baseForm).removeClass('shake-shake');
                    }, 1000);
                    error = true;
                } else {
                    let eMail = $('input:text', baseForm).val();
                    if (!/^\\S+@\\S+\\.\\S+$/.test(eMail))
                    {
                        $('input:text', baseForm).addClass('shake-shake');
                        setTimeout(() => {
                            $(' input:text', baseForm).removeClass('shake-shake');
                        }, 1000);
                        error = true;
                        if (typeof lngMessages !== 'undefined')
                        {
                            $('.email-signup-kont form .error').remove();
                            let errorMsg = lngMessages['Email cím nem tűnik érvényesnek'];
                            $('input:text', baseForm).after('<div class="error mt-2 text-danger">' + errorMsg + '</div>');
                            setTimeout(() => {
                                $('.email-signup-kont form .error').remove();
                            }, 5000);
                        }
                    }
                }

                if ($('html').data('locale') == 'de_DE')
                {
                    if ($('[name="orszag"]', baseForm).val() == '')
                    {
                        $('[name="orszag"]', baseForm).parents('.fancy-select-kont').addClass('shake-shake');
                        setTimeout(() => {
                            $('[name="orszag"]', baseForm).parents('.fancy-select-kont').removeClass('shake-shake');
                        }, 1000);
                        error = true;
                    }
                }
            }


            if (!error)
            {
                $(baseForm).submit();
            }
        });
    }

    atmeretezesKezeles()
    {
        if (window.innerWidth < 991)
        {
            if (
                $('.main-content.ujadatlap .product-details .cart-ujadatlap').length > 0
                && $('.main-content.ujadatlap .product-details .image-and-texts-kont .image').length > 0
                )
            {
                $('.main-content.ujadatlap .product-details .cart-ujadatlap').detach().insertAfter($('.main-content.ujadatlap .product-details .image-and-texts-kont .image'));
            }

            if ($('.frontpage-slider-v4-kont .left-side-kont .frontpage-slider-v4').length > 0)
            {
                $('.frontpage-slider-v4-kont .left-side-kont .frontpage-slider-v4 .slide-item:not(.is-video)').each((i, sl) => {
                    var pic_mobile = $(sl).data('pic_mobile');
                    if (typeof pic_mobile != 'undefined')
                    {
                        $(sl).css('background-image', "url('"+pic_mobile+"')");
                    }
                });
            }

            if ($('header.main-line .menu') && $('header.main-line .menu').offset())
            {
                $('header.main-line .menu').css('width', 'calc(100vw - '+$('header.main-line .menu').offset().left+'px)');
            }

            if ($('.termekadatlap-wrapper .right-panel').length > 0)
            {
                $('.termekadatlap-wrapper .right-panel').detach().insertAfter('.termekadatlap-wrapper .adatlap-bal .adatlap-top');
            }

        } else {

            if ($('.main-content.ujadatlap .product-details .image-and-texts-kont .cart-ujadatlap').length > 0)
            {
                $('.main-content.ujadatlap .product-details .image-and-texts-kont .cart-ujadatlap').detach().insertAfter($('.main-content.ujadatlap .product-details .image-and-texts-kont'));
            }


            if ($('.frontpage-slider-v4-kont .left-side-kont .frontpage-slider-v4').length > 0)
            {
                $('.frontpage-slider-v4-kont .left-side-kont .frontpage-slider-v4 .slide-item:not(.is-video)').each((i, sl) => {
                    var pic_desktop = $(sl).data('pic_desktop');
                    if (typeof pic_desktop != 'undefined')
                    {
                        $(sl).css('background-image', "url('"+pic_desktop+"')");
                    }
                });
            }

            if ($('.termekadatlap-wrapper .right-panel').length > 0)
            {
                $('.termekadatlap-wrapper .right-panel').detach().insertAfter('.termekadatlap-wrapper .right-panel-cont');
                // $('.termekadatlap-wrapper .right-panel-cont').remove();
            }

        }

        if ($('.product-tabs .tabs a').length > 0)
        {
            $('.product-tabs .tabs a').each((i, tabE) => {
                let tabKont = $(tabE).data('tab');

                if ($('.ujadatlap-tabok-kont').hasClass('design2024')) {
                    if ($(tabE).parent().find('.leftcontent').length > 0)
                    {
                        $(tabE).parent().find('.leftcontent').detach().appendTo($('.product-tabs #tab-' + tabKont));
                    }
                }
                if (window.innerWidth < 991) {
                    if ($(tabE).parent().find('.leftcontent').length == 0)
                    {
                        if ($('.ujadatlap-tabok-kont').hasClass('design2024'))
                        {
                            $('.product-tabs #tab-' + tabKont+' > div').detach().appendTo($(tabE).parent());
                        }
                    }
                } else {
                    if ($(tabE).parent().find('.leftcontent').length > 0)
                    {
                        $(tabE).parent().find('.leftcontent').detach().appendTo($('.product-tabs #tab-' + tabKont));
                    }
                }
            });
        }

        $('video').each( (i, v) => {

            let akt = $(v).find('source');
            let newSrc = this.isMobile() ? $(v).data('mobile_src') : $(v).data('full_src');

            if (newSrc && (!akt.length || akt.attr('src') !== newSrc)) {
                akt.remove();
                $('<source>')
                    .attr('src', newSrc)
                    .attr('type', 'video/mp4')
                    .appendTo($(v));

                $(v).get(0).load();
            }


        });

        Kosar.sidePanelAtmeretezes();
    }


    isMobile() {
        return window.innerWidth <= 991;
    }

}


class Base64 {

    constructor() {
        this._keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
    }

    // public method for encoding
    encode(input) {
        var output = "";
        var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
        var i = 0;

        input = Base64._utf8_encode(input);

        while (i < input.length) {
            chr1 = input.charCodeAt(i++);
            chr2 = input.charCodeAt(i++);
            chr3 = input.charCodeAt(i++);

            enc1 = chr1 >> 2;
            enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
            enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
            enc4 = chr3 & 63;

            if (isNaN(chr2)) {
                enc3 = enc4 = 64;
            } else if (isNaN(chr3)) {
                enc4 = 64;
            }

            output = output +
                this._keyStr.charAt(enc1) + this._keyStr.charAt(enc2) +
                this._keyStr.charAt(enc3) + this._keyStr.charAt(enc4);
        }

        return output;
    }

    decode (input) {
        var output = "";
        var chr1, chr2, chr3;
        var enc1, enc2, enc3, enc4;
        var i = 0;

        input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");

        while (i < input.length) {
            enc1 = this._keyStr.indexOf(input.charAt(i++));
            enc2 = this._keyStr.indexOf(input.charAt(i++));
            enc3 = this._keyStr.indexOf(input.charAt(i++));
            enc4 = this._keyStr.indexOf(input.charAt(i++));

            chr1 = (enc1 << 2) | (enc2 >> 4);
            chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
            chr3 = ((enc3 & 3) << 6) | enc4;

            output = output + String.fromCharCode(chr1);

            if (enc3 != 64) {
                output = output + String.fromCharCode(chr2);
            }
            if (enc4 != 64) {
                output = output + String.fromCharCode(chr3);
            }
        }

        output = Base64._utf8_decode(output);

        return output;
    }

    // private method for UTF-8 encoding
    _utf8_encode (string) {
        string = string.replace(/\r\n/g,"\n");
        var utftext = "";

        for (var n = 0; n < string.length; n++) {
            var c = string.charCodeAt(n);

            if (c < 128) {
                utftext += String.fromCharCode(c);
            }
            else if((c > 127) && (c < 2048)) {
                utftext += String.fromCharCode((c >> 6) | 192);
                utftext += String.fromCharCode((c & 63) | 128);
            }
            else {
                utftext += String.fromCharCode((c >> 12) | 224);
                utftext += String.fromCharCode(((c >> 6) & 63) | 128);
                utftext += String.fromCharCode((c & 63) | 128);
            }
        }

        return utftext;
    }

    // private method for UTF-8 decoding
    _utf8_decode (utftext) {
        var string = "";
        var i = 0;
        var c = c1 = c2 = 0;

        while ( i < utftext.length ) {
            c = utftext.charCodeAt(i);

            if (c < 128) {
                string += String.fromCharCode(c);
                i++;
            }
            else if((c > 191) && (c < 224)) {
                c2 = utftext.charCodeAt(i+1);
                string += String.fromCharCode(((c & 31) << 6) | (c2 & 63));
                i += 2;
            }
            else {
                c2 = utftext.charCodeAt(i+1);
                c3 = utftext.charCodeAt(i+2);
                string += String.fromCharCode(((c & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63));
                i += 3;
            }
        }

        return string;
    }
}


for (const key of Reflect.ownKeys(General.prototype)) {
    const exportedItem = General.prototype[key];
    if (
        typeof exportedItem === 'function'
        && !key.startsWith('_')
        && key !== 'constructor'
        && key !== 'init'
    ) {
        window[key] = exportedItem;
    }
}

export {General, Base64 };


